/*
Usage Notes: 

The following web component can be dropped into any standard Shopify theme (i.e. non-headless), using Liquid to pass product data:

  {% assign skioSellingPlanGroups = product.selling_plan_groups | where: 'app_id', 'SKIO' %}
  {% if skioSellingPlanGroups.size > 0 %}
    <skio-plan-picker 
      product='{{ product | json | escape }}'
      selectedVariant='{{ product.selected_or_first_available_variant | json | escape }}'
      formId='{{ product_form_id }}'
      externalPriceSelector='#price-inner-button .money'
      externalPriceSelectorWithCurrency='[data-product-price-list] .money'
      currency='USD'
      useVariantInputClickEvents='false'
      variantInputSelector=''
      >
    </skio-plan-picker>
    <input type="hidden" aria-hidden="true" name="selling_plan" value="">
    <script src="{{ 'skio-plan-picker-component.js' | asset_url }}" type="module"></script>
    {% render 'skio-details' %}
  {% endif %}

  Note: formId not required if element is inside of a form already

  Example variantChanged event dispatch:
  document.dispatchEvent( new CustomEvent("variantChanged", { detail: { variantId: variant.id } }) );
*/

import {
  LitElement,
  html,
  css,
} from "https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js";

const skioStyles = css`

.header__grid {
    margin-bottom: 11px;
    font-size: 14px;
    line-height: 19.6px;
    font-weight: 600;
}

.skio-group-container {
    border: 0;
    border-radius: 20px;
    /* padding: 13px 22px 21px 22px; */
    background:#442F2C1C;
    padding: 10px 22px;
    border: 2px solid transparent;
    box-sizing: border-box;
 }

 .skio-group-container.skio-group-container--selected {
    border: 2px solid #442E2B;
    background:#FFFFFF;
 }
  .skio-group-container:last-child {
        margin-top: 13px !important;
 }

  .skio-plan-picker {
    display: flex;
    flex-direction: column;
    /* gap: 10px; */
    padding: 0;
    border: 0;
  }
  .skio-onetime-second {
    order: 2;
  }

  .skio-plan-picker-title {
    color: #0d3635;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    margin-bottom: 16px;
    opacity: .8;
    display:none;
  }
  
  .skio-group-container {
    display: none;
  }
  .skio-group-container--available {
    display: block;
    position: relative;
    margin-bottom: 0px;
    display: flex;
    align-items: center;
    width: 100%;
    transition: all ease-in-out 0.3s;
  }
  .skio-group-container--selected {
    
  }
  
  .skio-group-input {
    // position: absolute;
    // width: 0px;
    // height: 0px;
    // opacity: 0;
     position: relative;
    width: 20px;
    height: 20px;
    opacity: 1;
    cursor: pointer;
    min-width: 20px;
    min-height: 20px;
    margin: 0 0 0 19px;
    display:none;
  }
  .skio-group-input:focus-visible ~ .skio-group-label {
    outline: 2px #ccc solid;
    outline-offset: 4px;
    border-radius: 5px;
     width: 100%;
  }
  
  .skio-group-label {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    padding: 0;
    width: 100%;
    position:relative;
  }

  .skio-group-label::before {
      content: "";
      width: 16px;
      height: 16px;
      border: 2px solid #442F2C;
      border-radius: 100%;
      position: absolute;
      left: 0;
      top: 10px;
  }

  .skio-group-label::after{
    content: "";
      width: 12px;
      height: 12px;
      background: #442F2C;
      border-radius: 100%;
      position: absolute;
      left: 4px;
      top: 14px;
      opacity:0;
  } 

  .skio-group-container--selected .skio-group-label::after{ opacity:1; }

  .skio-group-container--selected .skio-group-topline,
  .skio-group-container--selected .skio-price {
    
  }

  .skio-group-container:last-child{ margin-bottom:0px; }
  .skio-group-container:last-child.skio-group-container--selected{ margin-bottom:0px; }
  
  .skio-group-topline {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: calc(100% - 28px); 
    font-weight: 700;
    line-height: 19.6px;
    text-transform: uppercase;
    font-size: 14px;
    padding-left: 33px;
    margin-bottom:0px;
  }
  .subs-container .skio-group-topline {
    align-items: flex-start;
  }
  .skio-group-topline .skio-group-sub-title {
     font-weight: 600;
     line-height: 22.8px;
     text-transform: lowercase;
     font-size: 12px;
     letter-spacing: -0.24px;
  }
   .subs-container .skio-group-sub-title {
       margin-top: 5px; 
   }
   .subs-container {
        padding-top:16.5px;
   }
   .subs-container .skio-group-label::before {
        top: 0;
    }
    .subs-container .skio-group-label::after {
       top: 4px;
    }
    .subs-container svg.bg-image {
          position: absolute;
          right: 0;
          bottom: 0;
    }
   .skio-group-topline .skio-group-sub-title .skio-group-sub-title-compare {
     color: #442F2C;
     font-weight: 400;
     line-height: 190%;
     letter-spacing: -0.24px;
     text-decoration: line-through;
      margin-right: 6px;
     //display:block;
  } 

 .skio-group-topline .skio-save {
    line-height: 18.2px;
    font-size: 13px;
    border-radius: 100px;
    border: 2px solid #442F2C;
    padding: 4px 9px 2px 11px;
 }

.skio-group-container--selected .skio-group-topline .skio-save {
    background: linear-gradient(86deg, #578B04 0.16%, #70B600 100.16%);
    color: #FFFFFF;
    border: 0;
    padding: 5px 10px 3px 12px;
}
 
  // .skio-group-container:last-child .skio-group-topline{ margin-bottom:16px; }
  
  .skio-radio__container {
    display: none;
  }
  
  .skio-radio {
    transition: transform 0.25s cubic-bezier(0.4,0,0.2,1), opacity 0.25s cubic-bezier(0.4,0,0.2,1);
    transform-origin: center;
    transform: scale(0);
    opacity: 0;
  }
  .skio-group-label:hover .skio-radio {
    transform: scale(1);
    opacity: 0.75;
  }
  .skio-group-container--selected .skio-group-label .skio-radio {
    transform: scale(1);
    opacity: 1;
  }
  
  .skio-price {
    color: #442F2C;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    margin-left: auto;
    letter-spacing: -0.32px;
  }
  
  .skio-group-container--selected .skio-price {
    color: #EC1758;
  }
  .skio-price span[skio-compare-price]{
    color: #442F2C;
    font-size: 14px;
    font-weight: 400;
    line-height: 26.6px;
   letter-spacing: -0.28px;
    text-decoration: line-through;
    margin-right:6px;
  }
  
  .skio-group-content {
    width: auto;
    opacity: 1;
  }

   .skio-group-content ul li {
       color: #442F2C;
      font-size: 13px;
      font-weight: 600;
      line-height: 27.3px; 
   }
   
   .skio-group-content ul {
      margin: 9px 0px 10px;
       padding-left: 33px;
   }
   .skio-group-content ul li::marker {
     font-size: 2rem;
   
   }
  
  /* Hide frequency if not selected */
  // .skio-group-container:not(.skio-group-container--selected) .skio-group-content {
  //   max-height: 0;
  //   opacity: 0;
  //   pointer-events: none;
  // }
  
  .skio-group-title {
    min-width: max-content;
   
  }
  
  .skio-frequency {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 8px 30px 8px 10px;
    width: 100%;
    font-size: 14px;
    font-family: inherit;
    white-space: nowrap;
    text-overflow: ellipsis;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
    background-position: right 10px top 50%;
    background-size: 18px;
    background-repeat: no-repeat;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;

    margin-top: 15px;
    border-radius: 0;
    border: 0;
    background-color: #fff;
  }
  .skio-frequency.skio-frequency--one {
    background-image: none;
    pointer-events: none;
  }
  
  .skio-frequency span {
    text-transform: lowercase;
  }

  /*.skio-group-container--available:hover  {
      background: rgb(37, 155, 154);
  }
  .skio-group-container--available:hover .skio-price {
     color: rgb(255, 255, 255);
  }
  .skio-group-container--available:hover .skio-group-title {
     color: rgb(255, 255, 255);
  }
  .skio-group-container--available:hover .skio-group-topline {
    color: rgb(255, 255, 255);
  }*/

  .dropdown-inner  {
    position: relative;
    margin-top: 0px;
    margin-bottom:0px;
    display: inline-block;
}
  .dropdown-inner .styledSelect {
    color: #442F2C;
    width: 100%;
    padding: 0px 40px 0px 7px;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
    font-size: 13px;
    font-weight: 700;
    line-height: 27.3px; /* 22.4px */
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: 14.5%;
    text-underline-offset: 17%;
    text-underline-position: from-font;
}
.dropdown-inner .styledSelect.active{ border-radius: 12px 12px 0 0;
}
.dropdown-inner ul {
    margin: 0px 0px 0px;
    color:#442F2C;
    font-size: 13px;
    cursor: pointer;
    list-style: none;
    position: absolute;
    width: calc(100% - 6px);
    left: 0px;
    background-color: #FFF;
    z-index: 1;
    top: 0;
    padding: 0px;
    border: 2px solid #442F2C;
    border-radius: 0;
}
.dropdown-inner ul.hide {
    height: 0;
    visibility: hidden;
}
.styledSelect::after {
    content: "";
    width: 16px;
    height: 16px;
    position: absolute;
    top: 6px;
    right: 13px;
    transition: all 0.5s ease 0s;
    background: url(https://cdn.shopify.com/s/files/1/0539/9779/7536/files/filter_downarrow.svg?v=1702019159) right center no-repeat;
}
.styledSelect.active::after {
    z-index: 11;
}
.styledSelect.active:after {
    transform: rotate(180deg);
    top: 10px;
}
.dropdown-inner ul li {
    padding: 2px 10px;
    border-top: 2px solid #442F2C;
    font-size: 13px;
    font-weight: 700;
    line-height: 27.3px;
    border-radius: 0px;
  }
  .dropdown-inner ul li[data-selected="true"] {
      background: rgba(68, 47, 44, 0.10);
  }
.dropdown-inner ul li:first-child{ border-top:0;padding: 4px 10px 2px 10px; }
.dropdown-inner ul li:last-child{ border-radius: 0px 0; }
.dropdown-inner  ul li: hover {
  background: #442F2C;
  color:#FFFFFF;
  
}
.skio-plan-picker{ margin:0; }

@media only screen and (max-width:749px) {
   .skio-group-topline {
      line-height: 18.2px;
      font-size: 13px;
       padding-left: 29px;
    }
    .skio-group-topline .skio-group-sub-title {
      line-height: 20.9px;
      font-size: 11px;
      letter-spacing: -0.22px;
   }
   .skio-price {
    font-size: 14px;
    line-height: 26.6px;
    letter-spacing: -0.28px;
   }
   .skio-group-label::before {
    width: 14px;
    height: 14px;
   }
   .skio-group-label::after {
        width: 10px;
        height: 10px;
    }
   .skio-group-container {
      padding: 10px 16px;
   }
   .skio-group-topline .skio-save {
    line-height: 16.8px;
    font-size: 12px;
    padding: 3px 6px 1px 8px;
   }
   .skio-price span[skio-compare-price] {
    font-size: 12px;
    line-height: 22.8px;
    letter-spacing: -0.24px;
    margin-right: 2px;
  }
  .skio-group-container--selected .skio-group-topline .skio-save {
    padding: 5px 8px 3px 10px;
  }
  .skio-group-content ul li {
    font-size: 12px;
    line-height: 25.2px;
  }
  .skio-group-content ul {
    margin: 9px 0px 9px;
    padding-left: 28px;
  }
  .skio-group-content ul li::marker {
    font-size: 12px;
  }
  .dropdown-inner .styledSelect {
    font-size: 12px;
    line-height: 25.2px;
    padding: 0px 35px 0px 5px;
  }
  .dropdown-inner ul {
      margin: 0px 0px 0px;
      padding:0;
      width: calc(100% - 0px);
  }
  .dropdown-inner ul li {
    padding: 2px 10px;
    font-size: 12px;
    line-height: 25.2px;
  }
  .styledSelect.active:after {
    right: 6px;
  }
  .subs-container svg.bg-image {
    width: 129px;
    height: 129px;
  }
}



 @media only screen and (min-width:750px) and (max-width:989px) {
   .skio-group-container {
      padding: 16.5px 10px 10px 10px;
   }
   .skio-group-topline .skio-save {
      padding: 2px 5px;
   }
   .skio-group-container--selected .skio-group-topline .skio-save {
      padding: 3px 6px;
  }
  .skio-price span[skio-compare-price] {
    margin-right: 0px;
  }
  .skio-price span[skio-compare-price] {
        display: block;
    }
  .subs-container svg.bg-image {
    width: 80px;
    height: 80px;
   }
 }



 
  @media(min-width:769px) and (max-width:991px){
    /*.skio-plan-picker-title { font-size:14px; }
    .skio-group-label { padding: 20px 12px !important; }
    .skio-group-container--selected .skio-group-label { padding: 19px 11px !important; }
    .skio-group-topline{ font-size:14px; }
    .skio-save { min-width: 99px; height: 30px; line-height:30px; }
    .skio-frequency{ font-size:13px !important; }
    */
  }

  @media (min-width: 0px) and (max-width: 768px) {
    /*.skio-plan-picker-title { font-size:14px; }
    .skio-group-label { padding: 20px 12px; }
    .skio-group-container--selected .skio-group-label { padding: 19px 11px; }
    .skio-group-topline{ font-size:14px;
    
    }
    .skio-save-active.skio-group-topline.one-time{
      display: grid;
      grid-template-columns: repeat(2, 1fr);
    }
    .skio-save-active.skio-group-topline.one-time .purchace-option-title{
      grid-column: 1 / -1;
    }
    .skio-save-active.skio-group-topline.one-time .skio-save{
      margin: 0px;
    }
    .skio-save-active.skio-group-topline.one-time  .skio-price{
      margin-top: -23.5px;
    }
    .skio-save { min-width: 99px; height: 30px; line-height:30px; margin: 0px 0px 0px -3px; }
    .skio-frequency{ font-size:13px; }
    .skio-group-container{ margin-bottom:8px; }

  }*/
`;

export class SkioPlanPickerComponent extends LitElement {
  static properties = {
    product: { type: Object }, //required
    productHandle: { type: String }, //optional (unless product isn't passed, then required)
    key: { type: String }, //optional, defaults to product.id; identifier for this instance of the Skio plan picker

    formId: { type: String }, //optional; if passed, used to connect input fields to form
    needsFormId: { type: Boolean }, //optional, defaults to false; if true, element needs to be passed a formId, else it searches for a form

    subscriptionFirst: { type: Boolean }, //optional, defaults to false; if true, shows subscription option above onetime
    startSubscription: { type: Boolean }, //optional, defaults to false; if true, auto-selects subscription on page load
    discountFormat: { type: String }, //optional, defaults to percent; can also pass "fixed"

    currency: { type: String }, //optional, defaults to 'USD', but can pass any 3 char identifier
    language: { type: String }, //optional, defaults to 'en-US', but can pass any similarly formatted language identifier
    moneyFormatter: {}, //placeholder for object

    externalPriceSelector: { type: String }, //optional, used to update the external price

    externalPriceSelectorWithCurrency: { type: String }, //optional, used to update the external price

    selectedVariant: { type: Object }, //placeholder for data
    skioSellingPlanGroups: {}, //placeholder for data
    availableSellingPlanGroups: {}, //placeholder for data
    selectedSellingPlanGroup: {}, //placeholder for data
    selectedSellingPlan: {}, //placeholder for data

    defaultFrequency: {}, //placeholder for data

    useVariantInputClickEvents: { type: Boolean }, // optional, allows use of variant input click events to update skio's selectedVariant
    variantInputSelector: {},
  };

  static styles = skioStyles;

  constructor() {
    super();
    this.product = null;
    this.selectedVariant = null;

    this.productHandle = null;

    this.purchaseOption = null;

    this.key = null;
    this.formId = null;
    this.needsFormId = false;

    this.skioSellingPlanGroups = [];
    this.availableSellingPlanGroups = [];

    this.selectedSellingPlanGroup = null;
    this.selectedSellingPlan = null;

    this.startSubscription = false;
    this.subscriptionFirst = false;

    this.skioMainProduct = true;

    this.discountFormat = "percent";

    this.externalPriceSelector = "[skio-external-price]";

    this.externalPriceSelectorWithCurrency =
      "[skio-external-price-with-currency]";

    this.currency = Shopify.currency.active;
    this.language = "en-US";
    this.moneyFormatter = new Intl.NumberFormat(this.language, {
      style: "currency",
      currency: this.currency,
    });

    this.defaultFrequency = null;

    this.useVariantInputClickEvents = null;
    this.variantInputSelector = null;
  }

  connectedCallback() {
    super.connectedCallback();

    const startSubAttr = this.getAttribute('data-start-subscription');
    if (startSubAttr === 'true' || (startSubAttr === null && this.startSubscription == true)) {
      this.purchaseOption = "subscription";
    }

    if (!this.product && this.productHandle) {
      this.fetchProduct(this.productHandle);
    }

    if (this.needsFormId && this.formId == null) {
      let forms = document.querySelectorAll('form[action="/cart/add"]');
      if (forms.length > 0) {
        let form;
        forms.forEach((el) => {
          if (el.hasAttribute("skio-key")) {
            if (el.getAttribute("skio-key") == this.key) form = el;
          }
        });
        if (!form) form = forms[0];
        this.formId = form.id;
        this.requestUpdate();
      }
    }
    let skio = this;
    document.addEventListener("variant:change", function (e) {
      //update variant id
      let variantId = e.detail.variant.id;
      let variant = skio.product.variants.find((x) => x.id == variantId);
      if (variant) skio.selectedVariant = variant;
      else skio.log("Unable to find variant with id: ", variantId);
      skio.requestUpdate();
    });

    if (this.useVariantInputClickEvents) {
      document.addEventListener("load", skio.addVariantClickEventListeners);
    }

    // this.skioSellingPlanGroups = this.product.selling_plan_groups.filter(
    //     (selling_plan_group) => selling_plan_group.app_id === "SKIO"
    //   );
    //  this.selectedSellingPlanGroup = this.skioSellingPlanGroups.length > 0?this.skioSellingPlanGroups[0]:null;
      
    //  this.selectedSellingPlan = this.selectedSellingPlanGroup?this.selectedSellingPlanGroup.selling_plans[0]:null;
    
  }

  parseWidgetText(value) {
    if (!value) return [];

    let parsedValue = value;

    try {
      parsedValue = JSON.parse(value);
    } catch (error) {
      parsedValue = value;
    }

    if (Array.isArray(parsedValue)) {
      return parsedValue.map((text) => String(text).trim()).filter(Boolean);
    }

    if (typeof parsedValue === "string") {
      return parsedValue.split(/\r?\n/).map((text) => text.trim()).filter(Boolean);
    }

    return [];
  }
  
  render() {
   
    if (
      !this.product ||
      !this.selectedVariant ||
      this.skioSellingPlanGroups.length == 0
    )
      return;

    
   
     let servingsNumber = this.getAttribute('data-servings-metafield');
     let widgetText = this.getAttribute('data-widget-text') || this.getAttribute('data-widget-text-metafield');
     let widgetColor = this.getAttribute('data-badge-color');
     let customDiscount = this.getAttribute('data-custom-discount');
      console.log('customDiscount',customDiscount)
     if (servingsNumber) servingsNumber = Number(servingsNumber);
     widgetText = this.parseWidgetText(widgetText);

    
     // let onetimePrice = this.moneyFormatter.format(this.selectedVariant.price / 100)
     // let subsPrice = ''; 
       
     // if(this.selectedVariant.selling_plan_allocations.length > 0) {
     //   subsPrice = this.moneyFormatter.format(this.selectedVariant.selling_plan_allocations[0].price / 100)
     // }
   // console.log('render',servingsNumber, widgetText, this.selectedSellingPlanGroup);
   
    
    let proType = "One Time";
    let proPrice = "";
    if (document.querySelector("[data-subs-text]") != null) {
      if (this.selectedSellingPlanGroup == null) {
        if (this.selectedVariant.title.includes("Default Title")) {
          proType = "One Time";
        } else {
          proType = "&nbsp/ One Time";
        }
        proPrice = theme.Currency.formatMoney(
          this.selectedVariant.price,
          theme.settings.moneyFormat
        );
      } else if (
        this.selectedSellingPlanGroup != null &&
        this.selectedSellingPlan != undefined
      ) {
        if (this.selectedVariant.title.includes("Default Title")) {
          proType = this.selectedSellingPlan.name;
        } else {
          proType = `&nbsp/ ${this.selectedSellingPlan.name}`;
        }
        proPrice = theme.Currency.formatMoney(
          this.price(this.selectedSellingPlan, false),
          theme.settings.moneyFormat
        );
      }
      document.querySelector("[data-subs-text]").classList.remove("subs-hide");
      document.querySelector("[data-subs-text]").innerHTML = proType;
      document.querySelector("[js-data-product-total-price-2]").innerHTML =
        proPrice;
      document.querySelector("[js-btn-price-desktop]").innerHTML = proPrice;
      document.querySelector("[data-product-price]").innerHTML = this.price(this.selectedSellingPlan);
    }
    this.updateExternalPrice();
    // this.myVariable = ''
    //  this.product.variants.map(variant =>
    //     variant.id == "40562350162003" &&
    //    this.myVariable = `<span class="skio-save">Save <span skio-discount>30%</span></span>`
    //   )

    // console.log("this.product.variants:",this.product.variants)
    // console.log("this.selectedVariant:", window.compare_price[this.selectedVariant.id])
    let convertionrate = Shopify.currency.rate || 1
    var customOneTimePrice = this.selectedVariant.price;
    let discountAmount = this.customDiscountAmount(customOneTimePrice, customDiscount);
    let finalPrice = customOneTimePrice - discountAmount;

    console.log("Original Price:", customOneTimePrice);
    console.log("Discount:", discountAmount);
    console.log("Final Price after Discount:", this.moneyFormatter.format(finalPrice / 100));
    if(customDiscount != '' && window.customDiscountEnabled && this.selectedSellingPlanGroup == null){
      const comparePrice = this.selectedVariant.compare_at_price || customOneTimePrice;
      document.querySelectorAll('[add-to-cart-price]').forEach((el) => {
        let priceHtml = `<span>${this.moneyFormatter.format(finalPrice / 100)}</span>`;
        if(comparePrice > finalPrice){
          priceHtml += ` <span><s class="price-item price-item--regular">${this.moneyFormatter.format(comparePrice / 100)}</s></span>`;
        }
        el.innerHTML = priceHtml;
      });
    } else if(this.selectedSellingPlanGroup != null && this.selectedSellingPlan != null){
      const subsPrice = this.price(this.selectedSellingPlan, false);
      const comparePrice = this.selectedVariant.compare_at_price || customOneTimePrice;
      document.querySelectorAll('[add-to-cart-price]').forEach((el) => {
        let priceHtml = `<span>${this.moneyFormatter.format(subsPrice / 100)}</span>`;
        if(comparePrice > subsPrice){
          priceHtml += ` <span><s class="price-item price-item--regular">${this.moneyFormatter.format(comparePrice / 100)}</s></span>`;
        }
        el.innerHTML = priceHtml;
      });
    }
    // if(window.customDiscountEnabled){
    //   console.log('window.customDiscountEnabled bcz it true',this.selectedVariant.price , window.customDiscountEnabled)
    // }
    
    
    return html`
    
    <div class="header__grid">
        <span class="key">
          
            FREQUENCY:
          
        </span>
        
    </div>
    
      <fieldset class="skio-plan-picker" skio-plan-picker="${this.key}">
      <p class="skio-plan-picker-title">Choose an Option</p>
        <input ${
          this.formId !== null ? html`form="${this.formId}"` : ""
        } name="selling_plan" type="hidden" value="${
      this.selectedSellingPlan !== null ? this.selectedSellingPlan?.id : ""
    }" />
        <input ${
          this.formId !== null ? html`form="${this.formId}"` : ""
        } name="properties[Discount]" type="hidden" value="${
      this.selectedSellingPlan !== null
        ? this.discount(this.selectedSellingPlan).percent
        : ""
    }" 
          ?disabled="${this.selectedSellingPlan == null ? true : false}" />
        
        <div class="skio-group-container ${
          this.product.requires_selling_plan == false
            ? "skio-group-container--available"
            : ""
        } ${
      this.selectedSellingPlanGroup == null
        ? "skio-group-container--selected"
        : ""
    } ${
      this.subscriptionFirst ? "skio-onetime-second" : ""
    }" skio-group-container 
          @click=${() => this.selectSellingPlanGroup(null)} >
        
          <input id="skio-one-time-${
            this.key
          }" class="skio-group-input" name="skio-group-${
      this.key
    }" type="radio" value="" 
            skio-one-time ?checked=${
              this.startSubscription == false &&
              this.product.requires_selling_plan == false
                ? true
                : false
            }>
          <label class="skio-group-label" for="skio-one-time-${this.key}">
            <div class="skio-group-topline one-time ${this.selectedVariant.id == "40562350162003"?'skio-save-active':''}">
            
              <div class="skio-radio__container">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"></circle>
                  <circle class="skio-radio" cx="12" cy="12" r="7" fill="currentColor"></circle>
                </svg>
              </div>
              <div class="skio-group-title">
             One-Time Purchase 
             
              ${
  servingsNumber
    ? html`
        <div class="skio-group-sub-title">
          ${
            window.customDiscountEnabled && customDiscount != ''
              ? this.moneyFormatter.format(finalPrice / servingsNumber / 100)
              : this.moneyFormatter.format(
                  this.selectedVariant.price / servingsNumber / 100
                )
          } per stick
        </div>
      `
    : html``
}
 
               </div>
                ${
  window.customDiscountEnabled && customDiscount != ''
    ? html`
        <div class="skio-price">
        <span skio-compare-price="">
            ${this.moneyFormatter.format(this.selectedVariant.price / 100)}
          </span>
          <span skio-onetime-price>
            ${this.moneyFormatter.format(finalPrice / 100)}
          </span>
          
        </div>
      `
    : html`
        <div class="skio-price">
          <span skio-onetime-price>
            ${this.moneyFormatter.format(this.selectedVariant.price / 100)}
          </span>
        </div>
      `
}

              
              ${
                 this.selectedVariant.id == "40562350162003"
                   ? html`<span class="skio-save">Save <span skio-discount>30%</span></span>`
                   : ""
              }
              <div class="skio-price" style="display: flex; flex-direction: column; display:none;">
                ${this.selectedVariant && window.compare_price && window.compare_price.hasOwnProperty(this.selectedVariant.id)
                      ? parseFloat(window.compare_price[this.selectedVariant.id]) < this.selectedVariant.price / 100
                          ? html`<span skio-onetime-price>${this.moneyFormatter.format(
                                window.compare_price[this.selectedVariant.id] * convertionrate
                            )}</span><del class="skio_compare-price" style="opacity: 0.75;">${this.moneyFormatter.format(this.selectedVariant.price / 100)}</del>`
                          : html`<span skio-onetime-price>${this.moneyFormatter.format(this.selectedVariant.price / 100)}</span>`
                      : ""
                  }

              </div>
            </div>
          </label>
        </div>
        ${
          this.availableSellingPlanGroups
            ? this.availableSellingPlanGroups.map(
                (group, index) =>
                  html`
            <div class="subs-container skio-group-container skio-group-container--available ${
              this.selectedSellingPlanGroup == group
                ? "skio-group-container--selected"
                : ""
            }" skio-group-container
              @click=${() => this.selectSellingPlanGroup(group)}>


                <svg class="bg-image" width="156" height="156" viewBox="0 0 156 156" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_6080_957" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="156" height="156">
                <rect width="156" height="156" rx="20" fill="#D9D9D9"/>
                </mask>
                <g mask="url(#mask0_6080_957)">
                <g opacity="0.24">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M30.9732 156.065C31.4446 156.4 31.9334 156.735 32.4224 157.07L32.4274 157.074C47.0337 166.849 62.6826 170.985 79.7458 171.894C81.8747 172.019 84.0351 172.082 86.2269 172.113C85.823 170.17 85.4819 168.196 85.2033 166.191C72.1784 165.846 55.4307 163.497 45.3282 156.791C45.2114 156.704 45.0947 156.623 44.9779 156.542L43.6721 156.542L44.2364 156.135C44.2645 156.114 44.2926 156.093 44.3207 156.073L44.0147 155.852L44.6378 155.852C44.7548 155.771 44.8719 155.69 44.9889 155.602C55.1174 148.897 71.9081 146.548 84.9665 146.203C85.2458 144.198 85.5877 142.224 85.9927 140.281C83.7953 140.312 81.6293 140.375 79.4949 140.5C62.3879 141.409 46.6989 145.545 32.055 155.32L32.05 155.324C31.6887 155.571 31.3274 155.818 30.9732 156.065ZM45.9545 156.114C46.1739 156.219 46.3932 156.329 46.6125 156.447C56.8436 161.147 67.7993 163.152 79.7595 163.59C81.4502 163.653 83.1722 163.684 84.9257 163.684C84.6725 161.34 84.5497 158.944 84.5333 156.543L84.293 156.543C84.2887 153.911 84.4099 151.279 84.6882 148.71C82.9302 148.71 81.2037 148.741 79.5087 148.804C67.5177 149.242 56.5339 151.247 46.2765 155.947C46.1692 156.005 46.0619 156.06 45.9545 156.114ZM87.1831 155.851L87.4122 155.851C87.3473 195.237 118.136 227.29 156.023 227.321C193.909 227.321 224.804 195.266 224.869 155.881L224.987 155.881C224.594 116.785 193.748 85.0734 155.968 85.073C118.206 85.1037 87.478 116.783 87.1831 155.851ZM249.27 156.19C249.657 156.161 250.061 156.131 250.481 156.1C249.779 156.022 249.121 155.965 248.505 155.913L248.292 155.894L248.134 155.881L245.24 155.881C241.434 155.58 240.242 155.458 239.048 155.39C237.444 155.299 235.834 155.305 227.876 155.103C227.841 152.941 227.713 150.779 227.489 148.68C229.248 148.68 230.974 148.711 232.669 148.774C244.63 149.244 255.621 151.218 265.894 155.95L266.316 156.144L265.667 156.444C255.421 161.176 244.458 163.15 232.528 163.62C230.837 163.683 229.115 163.714 227.361 163.714C227.584 161.615 227.712 159.453 227.747 157.291C231.07 157.206 233.283 157.158 234.85 157.124C237.027 157.077 237.96 157.056 238.89 157.004C239.586 156.964 240.281 156.906 241.497 156.804L241.497 156.804C242.362 156.732 243.489 156.638 245.067 156.513L248.315 156.513C248.438 156.503 248.562 156.492 248.688 156.481C249.305 156.429 249.965 156.372 250.669 156.294C250.18 156.258 249.714 156.223 249.27 156.19ZM267.944 156.113L268.267 155.88L267.629 155.88C267.48 155.771 267.33 155.667 267.18 155.574C256.998 148.868 240.199 146.518 227.14 146.142C226.854 144.137 226.505 142.163 226.095 140.22C228.26 140.251 230.426 140.314 232.593 140.439C239.72 140.847 246.596 141.787 253.253 143.448L253.284 143.448C253.442 143.51 253.599 143.604 253.756 143.698C253.772 143.683 253.788 143.667 253.803 143.651C253.819 143.636 253.835 143.62 253.85 143.604C262.958 145.954 271.691 149.714 280.081 155.292C280.458 155.563 280.849 155.834 281.244 156.106C280.76 156.438 280.279 156.77 279.818 157.102C271.449 162.68 262.738 166.44 253.655 168.79C253.623 168.758 253.592 168.727 253.56 168.696C253.404 168.79 253.247 168.884 253.09 168.946L253.059 168.946C246.419 170.607 239.56 171.547 232.451 171.955C230.29 172.08 228.13 172.143 225.97 172.174C226.379 170.231 226.727 168.257 227.012 166.252C240.039 165.876 256.794 163.526 266.95 156.82C267.099 156.727 267.249 156.623 267.398 156.514L268.5 156.514L267.944 156.113ZM283.377 156.056L283.547 155.88L283.207 155.88L283.002 155.668L282.976 155.642C282.638 155.306 282.3 154.97 281.932 154.634C275.047 147.991 265.967 143.416 256.356 140.346C262.714 131.447 266.118 120.888 268.203 110.109L268.608 107.947L266.848 106.694C258.049 100.615 248.434 95.6646 237.884 94.0665C242.577 84.8233 245.857 74.9221 246.218 65.1462C246.217 64.876 246.225 64.6139 246.232 64.3558C246.239 64.105 246.247 63.8579 246.246 63.6108L246.245 62.4202L245.114 62.4202C244.879 62.4202 244.635 62.428 244.392 62.4359C244.149 62.4437 243.906 62.4515 243.67 62.4515C234.253 62.8587 224.748 66.2739 215.871 71.1931C214.347 60.1952 209.559 50.1999 203.705 41.0509L202.508 39.2334L200.438 39.6409C190.082 41.8026 179.949 45.3744 171.42 52.0168C168.454 41.9902 164.043 32.559 157.658 25.3838C157.447 25.1305 157.221 24.8918 156.991 24.6483C156.878 24.5298 156.765 24.4102 156.652 24.2871L155.835 23.4405L155.02 24.2871C154.908 24.4089 154.796 24.5273 154.686 24.6446C154.455 24.8894 154.229 25.1292 154.017 25.3838C147.656 32.559 143.277 41.9902 140.343 52.0164C131.793 45.4053 121.648 41.8327 111.285 39.6393L109.212 39.2326L108.022 41.0493C102.199 50.23 97.4751 60.1939 95.9551 71.1918C87.0631 66.2724 77.5457 62.8569 68.1589 62.4495C67.9037 62.4495 67.6485 62.4414 67.3974 62.4335C67.1543 62.4258 66.9151 62.4182 66.6834 62.4182L65.5533 62.4182L65.5553 63.6088C65.5557 63.8595 65.564 64.1102 65.5723 64.3609C65.5805 64.6115 65.5888 64.8622 65.5892 65.1128C65.9821 74.8887 69.2947 84.8213 74.0187 94.0646C63.4737 95.6625 53.876 100.613 45.0964 106.692L43.3405 107.945L43.7522 110.107C45.8733 120.917 49.3124 131.476 55.6997 140.343C46.0988 143.414 37.0656 147.988 30.1704 154.631C29.7942 154.976 29.4495 155.32 29.1048 155.696L28.9551 155.852L28.6721 155.852L28.8134 155.999L28.29 156.542L29.3354 156.542L29.4848 156.698C29.8286 157.074 30.1724 157.418 30.5476 157.763C37.4251 164.406 46.4352 168.98 56.0115 172.051C49.6406 180.918 46.2103 191.477 44.0946 202.287L43.684 204.449L45.4354 205.702C54.1925 211.781 63.7656 216.731 74.2836 218.329C69.5717 227.573 66.2676 237.505 65.8757 247.281C65.8753 247.532 65.867 247.782 65.8588 248.033C65.8506 248.284 65.8423 248.534 65.8419 248.785L65.8399 249.976L66.9671 249.976C67.1982 249.976 67.4368 249.968 67.6793 249.96C67.9297 249.953 68.1843 249.944 68.4388 249.944C77.8016 249.537 87.2946 246.122 96.1638 241.202C97.6799 252.2 102.392 262.164 108.2 271.345L109.387 273.161L111.455 272.755C121.791 270.561 131.91 266.989 140.438 260.377C143.364 270.404 147.732 279.835 154.077 287.01C154.288 287.265 154.514 287.505 154.744 287.749C154.854 287.867 154.966 287.985 155.077 288.107L155.89 288.953L156.705 288.107C156.818 287.984 156.93 287.865 157.042 287.747L157.042 287.746L157.043 287.746C157.273 287.502 157.498 287.263 157.709 287.01C164.077 279.835 168.477 270.404 171.436 260.377C179.942 267.02 190.05 270.591 200.379 272.753L202.444 273.161L203.637 271.343C209.476 262.194 214.252 252.199 215.773 241.201C224.626 246.12 234.108 249.535 243.501 249.942C243.736 249.942 243.978 249.95 244.221 249.958C244.463 249.966 244.706 249.974 244.941 249.974L246.068 249.974L246.07 248.783C246.07 248.536 246.063 248.289 246.056 248.038C246.049 247.78 246.041 247.518 246.041 247.248C245.682 237.472 242.41 227.571 237.729 218.327C248.252 216.729 257.842 211.779 266.619 205.7L268.375 204.446L267.971 202.285C265.891 191.506 262.495 180.947 256.154 172.048C265.74 168.978 274.797 164.403 281.665 157.76C282.041 157.415 282.386 157.071 282.731 156.726L282.936 156.514L283.819 156.514L283.377 156.056ZM78.4895 101.992C82.8961 109.105 87.961 115.653 92.8672 121.168C92.6309 121.612 92.4226 122.055 92.1895 122.552L92.1476 122.641C88.0015 119.515 86.8063 118.567 85.5625 117.688C84.1756 116.709 82.7282 115.814 77.0621 112.081C81.8902 116.941 83.0547 118.192 84.2905 119.369C85.437 120.46 86.6447 121.488 90.8963 125.273C90.8337 125.398 90.779 125.531 90.7243 125.664C90.6696 125.797 90.6149 125.931 90.5523 126.056C80.7919 122.207 78.1542 121.098 75.4681 120.123C72.6215 119.089 69.7206 118.205 58.2308 114.368C68.9448 120.195 71.5809 121.723 74.2889 123.111C76.8382 124.418 79.4511 125.601 88.9267 130.129C88.8925 130.218 88.8582 130.306 88.8243 130.393C88.7034 130.703 88.5867 131.002 88.4892 131.32C82.9677 130.27 81.4765 129.944 79.9709 129.711C78.3768 129.464 76.7667 129.321 70.3401 128.531C76.4701 130.694 77.9799 131.279 79.5206 131.765C80.9482 132.217 82.4023 132.584 87.5833 134.046C87.5365 134.218 87.4897 134.383 87.4429 134.547C87.3961 134.712 87.3493 134.876 87.3025 135.048C80.1142 135.362 72.1422 136.27 64.2031 138.056C59.2306 130.473 56.3593 121.638 54.4297 112.739C61.8301 107.851 69.8282 103.715 78.4895 101.992ZM107.075 94.6604C108.396 95.9136 109.685 97.2297 110.975 98.5771C107.056 101.867 103.483 105.564 100.288 109.606C99.1244 108.384 97.9923 107.193 96.8916 105.971C88.5575 96.7281 81.9807 87.1088 77.8815 76.0795L77.4084 74.7635C77.6837 74.8616 77.959 74.972 78.2266 75.0792C78.3865 75.1433 78.5436 75.2063 78.6963 75.2649C89.1569 79.4949 98.3028 86.1689 107.075 94.6604ZM113.846 50.7628C122.419 52.7369 130.9 55.7136 138.191 60.8836C136.447 69.2495 135.582 77.6782 135.344 85.3234C135.203 85.3704 135.054 85.4174 134.905 85.4644C134.756 85.5114 134.607 85.5584 134.465 85.6054C133.01 80.0144 132.654 78.4752 132.209 76.962C131.736 75.3544 131.164 73.7762 129.067 67.4008C129.832 74.0794 129.974 75.7561 130.214 77.4188C130.442 79.0089 130.761 80.5862 131.799 86.514C131.422 86.6394 131.077 86.7647 130.701 86.9214C126.246 76.8702 125.101 74.1319 123.831 71.4528C122.496 68.6364 121.023 65.8855 115.422 54.7734C119.115 66.7192 119.966 69.7304 120.963 72.6924C121.909 75.503 122.986 78.2692 126.748 88.5819C126.698 88.6034 126.646 88.6248 126.594 88.6467C126.416 88.7205 126.227 88.7985 126.058 88.8953C122.29 84.3521 121.289 83.0878 120.224 81.8795C119.093 80.5961 117.891 79.3758 113.226 74.3566C116.828 80.2462 117.681 81.7478 118.621 83.1926C119.471 84.4995 120.392 85.76 123.486 90.1799C123.047 90.3992 122.576 90.6499 122.137 90.9006C116.824 85.7619 110.474 80.4352 103.56 75.8291C105.177 66.8052 109.15 58.4706 113.846 50.7628ZM208.345 75.8304C201.447 80.4675 195.146 85.7627 189.818 90.9013L189.817 90.9008C189.377 90.6503 188.938 90.3998 188.467 90.1179C191.529 85.7007 192.446 84.4392 193.295 83.1331C194.234 81.6876 195.089 80.1875 198.675 74.2949C194.026 79.298 192.819 80.5187 191.689 81.8064C190.624 83.0187 189.628 84.2904 185.89 88.8333C185.781 88.7863 185.663 88.7315 185.545 88.6767C185.427 88.6218 185.309 88.567 185.199 88.52C188.926 78.2094 189.987 75.4422 190.92 72.6322C191.903 69.6697 192.743 66.6596 196.413 54.7117C190.847 65.8278 189.384 68.5766 188.058 71.3898C186.798 74.0639 185.661 76.7961 181.241 86.8279C181.053 86.7655 180.873 86.6953 180.693 86.625C180.512 86.5543 180.331 86.4835 180.141 86.4206C181.16 80.4932 181.473 78.9157 181.696 77.3257C181.93 75.6629 182.066 73.9864 182.81 67.3075C180.734 73.6824 180.167 75.2608 179.7 76.8682C179.26 78.3815 178.909 79.9206 177.472 85.5119C177.331 85.4649 177.182 85.418 177.032 85.371C176.883 85.324 176.734 85.2769 176.592 85.2299C176.329 77.6786 175.436 69.25 173.664 60.884C180.938 55.7142 189.41 52.7376 197.976 50.7637C202.698 58.4718 206.698 66.8064 208.345 75.8304ZM215.427 105.659C214.236 106.975 213.014 108.323 211.729 109.639C210.408 107.978 209.055 106.38 207.608 104.876C213.177 98.7637 214.329 97.5769 215.407 96.3261C216.501 95.057 217.518 93.7221 222.993 87.1104C216.564 92.7016 215.259 93.7406 214.023 94.8555C212.8 95.9587 211.645 97.1362 205.659 102.871C204.181 101.398 202.609 99.9881 201.006 98.6407L201.027 98.6193C202.21 97.4048 203.364 96.2213 204.547 95.0687C213.385 86.3897 222.604 79.5905 233.207 75.3292C233.526 75.1824 233.863 75.0547 234.19 74.9312C234.282 74.8966 234.372 74.8623 234.462 74.828L233.993 76.1439C229.962 87.0478 223.573 96.5416 215.427 105.659ZM257.597 112.741C255.697 121.64 252.855 130.476 247.908 138.058C239.994 136.241 231.988 135.363 224.798 134.987C224.751 134.815 224.704 134.651 224.656 134.486C224.609 134.322 224.562 134.157 224.514 133.985C229.689 132.538 231.143 132.171 232.568 131.717C234.108 131.226 235.615 130.634 241.739 128.47C235.308 129.261 233.694 129.412 232.095 129.663C230.588 129.899 229.096 130.225 223.599 131.259C223.52 131.055 223.449 130.859 223.378 130.663C223.308 130.467 223.237 130.272 223.158 130.068C232.623 125.538 235.237 124.357 237.787 123.049C240.494 121.661 243.127 120.132 253.802 114.308C242.323 118.145 239.426 119.037 236.582 120.075C233.9 121.054 231.265 122.162 221.519 125.995C221.424 125.744 221.298 125.462 221.173 125.211C225.393 121.429 226.598 120.401 227.744 119.31C228.98 118.133 230.148 116.883 234.963 112.02C229.306 115.772 227.863 116.664 226.479 117.64C225.239 118.514 224.046 119.455 219.912 122.579C219.697 122.121 219.452 121.663 219.207 121.204L219.188 121.169C224.076 115.655 229.119 109.138 233.502 101.994C242.169 103.686 250.213 107.853 257.597 112.741ZM234.848 99.7691C235.474 98.7351 236.069 97.7011 236.632 96.6358C247.434 97.9206 257.393 102.903 266.506 108.919C264.201 119.854 260.546 130.695 253.78 139.562C252.65 139.249 251.52 138.936 250.389 138.654C254.991 131.165 257.613 122.58 259.295 113.869L259.668 111.864L258.034 110.736C250.9 105.785 243.202 101.681 234.848 99.7691ZM194.311 93.596C195.753 92.1233 197.226 90.682 198.699 89.2721C211.581 77.0836 225.598 68.2792 242.826 64.3315C243.172 64.253 243.518 64.1823 243.864 64.1116C244.208 64.0413 244.553 63.971 244.897 63.8928C244.82 64.2485 244.751 64.6042 244.682 64.9599C244.611 65.3248 244.54 65.6898 244.461 66.0548C240.787 83.7893 232.491 98.2651 221.055 111.519C219.614 113.211 218.11 114.871 216.543 116.532C215.505 114.84 214.403 113.211 213.239 111.613C222.232 101.712 232.537 87.6119 235.153 75.3607C235.216 75.0473 235.278 74.7653 235.34 74.452L235.434 73.7626L234.774 73.888C234.46 73.9506 234.178 74.0133 233.896 74.076C222.096 76.8018 208.554 87.5802 199.088 96.9801L199.309 97.1994C197.705 95.9147 196.039 94.724 194.311 93.596ZM173.126 58.346C172.842 57.1554 172.557 55.9647 172.241 54.8054C180.768 47.7556 191.152 43.9644 201.665 41.5209C207.425 50.9832 212.245 61.3232 213.489 72.6031C212.487 73.1969 211.486 73.822 210.485 74.4471L210.478 74.4517C208.611 65.7724 204.674 57.7824 199.921 50.3565L198.82 48.6644L196.906 49.0404C188.527 50.795 180.338 53.5522 173.126 58.346ZM143.583 54.7369C143.562 54.72 143.54 54.7018 143.517 54.6798C145.762 45.1861 149.358 36.0992 154.711 27.3889C155.086 26.7622 155.462 26.1672 155.87 25.5713C156.06 25.8872 156.258 26.1952 156.456 26.5032C156.651 26.8064 156.847 27.1097 157.034 27.4206C166.446 42.6793 170.459 59.0354 171.368 76.8326C171.465 79.1512 171.532 81.5012 171.568 83.8825C169.432 83.3812 167.297 82.9738 165.099 82.6917L165.884 82.6918C165.516 69.0619 163.227 51.4527 156.742 40.8309C156.698 40.7609 156.654 40.6885 156.61 40.615C156.494 40.4253 156.375 40.2284 156.239 40.0476L155.861 39.4834L155.454 40.0476C155.376 40.173 155.297 40.3061 155.219 40.4393C155.141 40.5724 155.062 40.7055 154.984 40.8309C148.504 51.4525 146.304 69.0617 145.982 82.6916L146.797 82.6916C144.601 83.0048 142.467 83.3809 140.333 83.8821C140.329 81.7515 140.389 79.6208 140.479 77.5215C140.812 69.9703 141.679 62.7323 143.269 55.6824C143.286 55.6378 143.302 55.5958 143.316 55.5549C143.354 55.4519 143.389 55.3559 143.456 55.2438C143.518 55.0871 143.581 54.9618 143.675 54.8365C143.655 54.7958 143.621 54.7683 143.583 54.7369ZM157.039 70.1571C156.946 68.4552 156.756 66.7586 156.143 58.0639C155.401 66.7603 155.185 68.4558 155.063 70.1581C154.941 71.8475 154.911 73.5436 154.55 82.0963C152.478 82.1276 150.438 82.253 148.398 82.4722C148.407 81.8915 148.413 81.3142 148.419 80.7392C148.432 79.5769 148.444 78.4239 148.483 77.2709C148.87 64.6124 150.766 52.9879 155.332 42.1777C155.519 41.7393 155.707 41.301 155.895 40.8934C156.083 41.301 156.273 41.7393 156.462 42.1777C161 52.8626 162.934 64.2992 163.394 76.7698C163.46 78.6498 163.494 80.5298 163.497 82.4724C161.457 82.2531 159.416 82.1277 157.344 82.0964C157.127 73.5419 157.131 71.8469 157.039 70.1571ZM101.42 74.4485C100.415 73.8225 99.4105 73.1965 98.406 72.6018C99.643 61.3219 104.397 50.982 110.126 41.5193C120.647 43.9319 131.075 47.755 139.594 54.805C139.282 55.9957 139.001 57.155 138.721 58.3457C131.524 53.5517 123.295 50.7943 114.911 49.0395L112.995 48.6634L111.899 50.3554C107.171 57.75 103.26 65.7712 101.423 74.4505L101.42 74.4485ZM95.4964 116.531C94.0814 115.058 92.7291 113.554 91.4081 112.05C86.4074 106.347 82.0027 100.394 78.288 94.0647C78.2834 94.0417 78.2787 94.0194 78.2742 93.9975C78.2478 93.8706 78.2247 93.7597 78.2245 93.626L78.0361 93.626C73.1565 85.2287 69.5314 76.1421 67.38 66.0215C67.2219 65.3321 67.0637 64.6115 66.937 63.8908C67.6278 64.0162 68.3187 64.1728 69.0096 64.3295C86.0303 68.1837 99.9826 76.8318 112.716 88.7698C114.351 90.3365 115.986 91.9344 117.622 93.5952C115.897 94.7231 114.235 95.9137 112.636 97.1984L112.855 96.9791C103.328 87.6103 89.7802 76.8003 77.9724 74.0742C77.8311 74.0429 77.6819 74.0115 77.5328 73.9802C77.3836 73.9489 77.2344 73.9175 77.0931 73.8862L76.4336 73.7608L76.5603 74.4502C76.592 74.6066 76.6236 74.7553 76.6552 74.9039C76.6868 75.0529 76.7185 75.2019 76.7502 75.3588C79.3761 87.6414 89.7587 101.741 98.7845 111.611C97.6256 113.209 96.5295 114.839 95.4964 116.531ZM58.3668 139.56L58.3667 139.56C51.5714 130.693 47.912 119.82 45.5395 108.916C54.5704 102.9 64.5134 97.9185 75.3414 96.6339C75.9396 97.6993 76.5377 98.7333 77.1359 99.7673C68.7889 101.71 61.1047 105.814 53.9869 110.734L52.3878 111.862L52.7678 113.867C54.4774 122.578 57.1285 131.163 61.7555 138.651C60.6259 138.933 59.4963 139.247 58.3668 139.56ZM78.7429 210.402C83.1382 203.289 88.1902 196.741 93.0838 191.226C92.8481 190.782 92.6404 190.339 92.408 189.843L92.3661 189.753C90.8176 190.924 89.6818 191.789 88.8016 192.459L88.8014 192.459C87.3308 193.579 86.5737 194.156 85.7976 194.706C84.9742 195.289 84.1294 195.842 82.3885 196.981L82.3878 196.982L82.3865 196.982C81.203 197.757 79.6054 198.803 77.3192 200.313C79.4802 198.132 80.9054 196.678 81.9314 195.631L81.9315 195.631L81.9318 195.631C83.192 194.345 83.8498 193.674 84.5292 193.025C85.2712 192.317 86.039 191.636 87.6451 190.211C88.5143 189.439 89.629 188.45 91.118 187.121C91.0555 186.996 91.001 186.863 90.9464 186.73L90.9463 186.73C90.8918 186.596 90.8372 186.463 90.7748 186.338C87.0321 187.818 84.3394 188.892 82.2903 189.71L82.2881 189.711L82.2866 189.712C79.008 191.02 77.3777 191.671 75.729 192.271C74.0986 192.865 72.4503 193.409 69.1721 194.491L69.1716 194.491L69.1713 194.492C66.7409 195.294 63.4147 196.392 58.5361 198.026C63.2585 195.451 66.4076 193.716 68.6847 192.461L68.6854 192.46C71.561 190.876 73.046 190.057 74.5534 189.282C76.1632 188.455 77.7985 187.677 81.1802 186.069C83.1399 185.137 85.686 183.926 89.1534 182.265C89.1193 182.176 89.0851 182.088 89.0513 182.001C88.9307 181.691 88.8143 181.392 88.717 181.074C86.6301 181.472 85.1204 181.766 83.9684 181.99C82.0803 182.358 81.1532 182.538 80.2205 182.683C79.3206 182.823 78.4155 182.929 76.6372 183.139C75.2736 183.299 73.3964 183.52 70.6144 183.863C73.1045 182.982 74.8303 182.363 76.1051 181.906C77.9605 181.24 78.8606 180.917 79.7715 180.628C80.6297 180.357 81.4976 180.115 83.1831 179.646L83.1838 179.646C84.2948 179.337 85.7609 178.929 87.8134 178.348C87.7668 178.176 87.7201 178.011 87.6734 177.847C87.6267 177.682 87.58 177.518 87.5333 177.346C80.3635 177.032 72.4119 176.124 64.4931 174.338C59.5334 181.92 56.6695 190.756 54.7448 199.655C62.1262 204.543 70.1038 208.679 78.7429 210.402ZM107.255 217.734C108.573 216.48 109.858 215.164 111.145 213.817C107.236 210.527 103.673 206.83 100.486 202.788C99.325 204.01 98.1958 205.2 97.0979 206.423C88.7851 215.666 82.2252 225.285 78.1365 236.314L77.6646 237.63C77.9391 237.532 78.2136 237.422 78.4804 237.315L78.4806 237.315C78.6401 237.251 78.7969 237.188 78.9493 237.129C89.383 232.899 98.5055 226.225 107.255 217.734ZM114.009 261.631C122.56 259.657 131.019 256.68 138.292 251.51C136.552 243.144 135.689 234.716 135.452 227.071C135.311 227.024 135.162 226.977 135.014 226.93C134.865 226.883 134.716 226.836 134.576 226.789C134.001 229 133.599 230.578 133.294 231.771L133.294 231.771C132.829 233.593 132.593 234.517 132.325 235.432C132.049 236.373 131.739 237.304 131.11 239.192L131.11 239.192C130.664 240.53 130.058 242.349 129.191 244.993C129.517 242.141 129.729 240.201 129.885 238.785L129.885 238.783C130.093 236.884 130.198 235.927 130.334 234.975C130.473 234.008 130.645 233.045 130.992 231.104C131.215 229.855 131.51 228.201 131.916 225.88C131.54 225.755 131.195 225.629 130.82 225.473C129.096 229.374 127.868 232.174 126.938 234.296L126.937 234.297C125.471 237.641 124.743 239.302 123.968 240.941C123.203 242.559 122.393 244.155 120.784 247.326L120.783 247.327L120.783 247.328C119.59 249.678 117.958 252.892 115.581 257.62C117.125 252.612 118.171 249.173 118.939 246.651L118.939 246.651C120.002 243.158 120.53 241.421 121.107 239.701C121.678 238.001 122.297 236.316 123.528 232.967C124.332 230.781 125.396 227.885 126.878 223.812C126.855 223.802 126.833 223.793 126.809 223.783L126.724 223.747L126.724 223.747C126.546 223.673 126.358 223.595 126.189 223.499C124.8 225.178 123.788 226.409 123.01 227.355C121.684 228.969 121.04 229.753 120.37 230.515C119.738 231.234 119.083 231.934 117.808 233.296L117.807 233.297C116.809 234.363 115.432 235.834 113.39 238.037C115.005 235.39 116.066 233.629 116.83 232.362L116.83 232.361L116.831 232.361C117.766 230.809 118.255 229.996 118.771 229.201C119.338 228.327 119.937 227.475 121.194 225.685L121.194 225.684C121.817 224.797 122.602 223.679 123.624 222.214C123.186 221.995 122.717 221.744 122.278 221.493C116.979 226.632 110.645 231.959 103.749 236.565C105.362 245.589 109.325 253.923 114.009 261.631ZM208.266 236.564C201.385 231.926 195.1 226.631 189.786 221.493L189.785 221.493L189.784 221.494C189.346 221.744 188.908 221.994 188.439 222.276C189.56 223.898 190.393 225.095 191.04 226.024L191.041 226.025C192.156 227.626 192.719 228.434 193.254 229.261C193.8 230.103 194.318 230.965 195.363 232.704L195.364 232.705L195.368 232.712C196.115 233.955 197.132 235.647 198.62 238.099C196.589 235.907 195.216 234.441 194.221 233.378L194.22 233.377C192.943 232.013 192.286 231.311 191.652 230.588C190.98 229.82 190.334 229.028 189.003 227.395C188.234 226.451 187.235 225.225 185.869 223.561C185.759 223.608 185.642 223.662 185.524 223.717L185.523 223.718C185.406 223.772 185.289 223.827 185.179 223.874C186.54 227.648 187.544 230.411 188.317 232.536L188.317 232.538C189.655 236.216 190.296 237.98 190.885 239.762C191.428 241.402 191.928 243.057 192.887 246.237L192.887 246.238L192.889 246.244C193.661 248.805 194.732 252.355 196.364 257.682C193.977 252.902 192.346 249.669 191.158 247.313L191.158 247.313L191.156 247.31C189.582 244.189 188.784 242.607 188.031 241.004C187.257 239.357 186.529 237.688 185.054 234.305L185.053 234.302L185.052 234.3C184.133 232.191 182.923 229.416 181.231 225.566C181.044 225.628 180.865 225.699 180.685 225.769L180.685 225.769C180.504 225.84 180.323 225.91 180.134 225.973C180.531 228.288 180.821 229.94 181.039 231.188C181.38 233.135 181.549 234.099 181.685 235.068C181.819 236.019 181.92 236.975 182.122 238.868C182.272 240.285 182.479 242.227 182.796 245.086C181.936 242.439 181.336 240.619 180.895 239.281L180.894 239.279L180.894 239.279C180.273 237.395 179.966 236.465 179.694 235.526C179.428 234.61 179.195 233.685 178.735 231.859L178.735 231.859C178.435 230.666 178.038 229.09 177.472 226.882C177.331 226.929 177.182 226.976 177.033 227.023C176.884 227.07 176.735 227.117 176.594 227.164C176.331 234.715 175.441 243.144 173.674 251.51C180.929 256.68 189.379 259.656 197.923 261.63C202.633 253.922 206.623 245.588 208.266 236.564ZM215.329 206.734C214.142 205.419 212.922 204.071 211.641 202.755C210.323 204.416 208.974 206.014 207.531 207.518C210.077 210.32 211.698 212.087 212.809 213.299C214.123 214.732 214.727 215.39 215.31 216.068C215.805 216.644 216.285 217.234 217.172 218.326L217.173 218.327C218.24 219.639 219.896 221.675 222.876 225.284C219.266 222.136 217.276 220.431 216.006 219.343C215.02 218.499 214.468 218.026 213.93 217.539C213.244 216.919 212.581 216.276 211.073 214.816L211.072 214.815C209.895 213.675 208.204 212.037 205.587 209.523C204.113 210.996 202.545 212.406 200.946 213.753L200.968 213.776C202.148 214.99 203.297 216.173 204.478 217.325C213.293 226.004 222.488 232.803 233.064 237.065C233.382 237.211 233.719 237.339 234.044 237.463L234.045 237.463C234.136 237.497 234.227 237.532 234.315 237.566L233.848 236.25C229.827 225.346 223.455 215.852 215.329 206.734ZM257.392 199.653C255.497 190.754 252.662 181.918 247.727 174.336C239.834 176.153 231.848 177.031 224.677 177.407C224.63 177.579 224.582 177.743 224.535 177.908L224.535 177.908C224.488 178.073 224.441 178.237 224.394 178.409C226.235 178.925 227.604 179.304 228.668 179.598L228.672 179.599C230.587 180.129 231.513 180.385 232.427 180.677C233.282 180.95 234.126 181.255 235.761 181.844L235.761 181.844L235.762 181.845C237.064 182.314 238.867 182.965 241.574 183.924C239.017 183.609 237.223 183.395 235.89 183.236L235.889 183.236C233.878 182.997 232.914 182.882 231.955 182.731C231.071 182.592 230.193 182.422 228.504 182.096C227.321 181.867 225.74 181.561 223.481 181.135C223.402 181.339 223.332 181.535 223.261 181.731C223.19 181.926 223.119 182.122 223.041 182.326C226.621 184.044 229.218 185.28 231.202 186.224C234.45 187.77 236.053 188.533 237.632 189.345C239.172 190.136 240.688 190.974 243.682 192.628L243.685 192.63L243.686 192.63C245.941 193.876 249.034 195.585 253.606 198.086C249.018 196.548 245.804 195.484 243.418 194.693C239.849 193.511 238.13 192.941 236.431 192.319C234.851 191.741 233.288 191.118 230.274 189.917L230.273 189.917C228.181 189.082 225.389 187.969 221.406 186.399C221.311 186.65 221.185 186.932 221.06 187.183C222.659 188.619 223.824 189.658 224.716 190.454L224.719 190.456C226.175 191.755 226.906 192.408 227.615 193.084C228.329 193.765 229.02 194.471 230.407 195.889L230.408 195.89C231.417 196.92 232.794 198.327 234.815 200.374C232.328 198.72 230.657 197.621 229.448 196.827L229.443 196.823C227.914 195.818 227.125 195.299 226.354 194.754C225.531 194.173 224.73 193.562 223.073 192.3L223.073 192.3C222.237 191.663 221.185 190.862 219.803 189.815C219.589 190.272 219.345 190.73 219.101 191.188L219.1 191.189L219.081 191.225C223.956 196.739 228.987 203.256 233.358 210.4C242.003 208.708 250.026 204.541 257.392 199.653ZM234.701 212.625C235.325 213.659 235.919 214.693 236.481 215.758C247.254 214.473 257.188 209.491 266.278 203.475C263.979 192.54 260.333 181.699 253.585 172.832C252.457 173.145 251.33 173.458 250.202 173.74C254.792 181.229 257.408 189.814 259.085 198.525L259.457 200.53L257.827 201.658C250.712 206.609 243.033 210.713 234.701 212.625ZM194.268 218.798C195.706 220.271 197.175 221.712 198.644 223.122C211.493 235.31 225.475 244.115 242.659 248.062C243.004 248.141 243.349 248.212 243.694 248.282L243.694 248.282L243.694 248.282C244.038 248.353 244.381 248.423 244.724 248.501C244.648 248.145 244.579 247.79 244.51 247.434C244.439 247.069 244.368 246.704 244.289 246.339C240.624 228.605 232.35 214.129 220.944 200.875C219.506 199.183 218.005 197.523 216.443 195.862C215.407 197.554 214.308 199.183 213.147 200.781C222.117 210.682 232.395 224.782 235.005 237.033C235.034 237.181 235.064 237.321 235.093 237.462C235.126 237.619 235.159 237.776 235.192 237.942L235.285 238.631L234.627 238.506C234.314 238.443 234.033 238.381 233.751 238.318L233.751 238.318C221.982 235.592 208.474 224.814 199.033 215.414L199.253 215.195C197.653 216.479 195.992 217.67 194.268 218.798ZM173.137 254.048C172.854 255.239 172.57 256.429 172.254 257.589C180.76 264.638 191.117 268.43 201.603 270.873C207.349 261.411 212.156 251.071 213.396 239.791C212.398 239.197 211.399 238.572 210.401 237.947L210.393 237.942C208.531 246.622 204.604 254.612 199.864 262.037L198.765 263.73L196.856 263.354C188.499 261.599 180.331 258.842 173.137 254.048ZM143.669 257.657C143.649 257.674 143.626 257.692 143.604 257.714C145.843 267.208 149.429 276.295 154.769 285.005C155.144 285.632 155.518 286.227 155.925 286.823C156.114 286.507 156.312 286.199 156.51 285.891L156.51 285.891L156.51 285.89C156.705 285.587 156.899 285.284 157.086 284.973C166.474 269.715 170.477 253.359 171.383 235.561C171.48 233.243 171.547 230.893 171.583 228.511C169.452 229.013 167.323 229.42 165.13 229.702L165.913 229.702C165.546 243.332 163.263 260.941 156.795 271.563C156.751 271.633 156.707 271.705 156.663 271.779C156.548 271.969 156.429 272.166 156.293 272.346L155.916 272.911L155.51 272.346C155.432 272.221 155.354 272.088 155.276 271.955C155.198 271.822 155.12 271.688 155.041 271.563C148.578 260.941 146.383 243.332 146.062 229.702L146.876 229.702C144.685 229.389 142.556 229.013 140.428 228.512C140.424 230.642 140.484 232.773 140.574 234.872C140.905 242.424 141.77 249.662 143.356 256.712C143.374 256.756 143.389 256.798 143.404 256.839C143.441 256.942 143.476 257.038 143.543 257.15C143.605 257.307 143.668 257.432 143.762 257.557C143.741 257.598 143.708 257.626 143.669 257.657ZM156.893 244.969L156.893 244.97L156.893 244.971C156.759 246.676 156.547 249.359 156.197 254.33C155.76 249.194 155.506 246.5 155.346 244.804L155.346 244.803C155.235 243.628 155.17 242.932 155.12 242.236C155.047 241.225 155.008 240.212 154.91 237.73L154.91 237.729C154.845 236.062 154.754 233.733 154.609 230.298C152.542 230.266 150.508 230.141 148.472 229.922C148.482 230.502 148.488 231.079 148.494 231.654L148.494 231.654L148.494 231.655L148.494 231.656L148.494 231.656C148.506 232.818 148.518 233.971 148.557 235.123C148.944 247.782 150.834 259.406 155.389 270.216C155.575 270.655 155.763 271.093 155.95 271.5C156.138 271.093 156.327 270.655 156.515 270.216C161.042 259.531 162.971 248.095 163.43 235.624C163.496 233.744 163.53 231.864 163.533 229.922C161.498 230.141 159.462 230.266 157.396 230.298C157.303 233.96 157.25 236.365 157.214 238.051L157.213 238.054C157.164 240.303 157.143 241.271 157.091 242.237C157.051 242.965 156.994 243.693 156.893 244.969ZM101.612 237.947C100.611 238.572 99.6097 239.198 98.6084 239.792C99.8422 251.072 104.585 261.412 110.299 270.875C120.792 268.462 131.194 264.639 139.691 257.589C139.379 256.398 139.1 255.239 138.82 254.048C131.641 258.842 123.434 261.6 115.071 263.354L113.16 263.73L112.067 262.039C107.351 254.644 103.45 246.623 101.617 237.943L101.612 237.947ZM95.7063 195.863C94.2949 197.336 92.946 198.84 91.6285 200.344C86.6405 206.047 82.2471 212 78.542 218.329L78.5282 218.396C78.5018 218.523 78.4788 218.634 78.4786 218.768L78.2907 218.768C73.4236 227.165 69.8078 236.252 67.6619 246.372C67.5042 247.062 67.3465 247.782 67.2201 248.503C67.9091 248.378 68.5982 248.221 69.2873 248.064C86.2645 244.21 100.181 235.562 112.882 223.624C114.513 222.057 116.143 220.459 117.775 218.799C116.054 217.671 114.397 216.48 112.802 215.196L113.02 215.415C103.518 224.784 90.0048 235.594 78.2271 238.32C78.0862 238.351 77.9374 238.382 77.7886 238.414C77.6398 238.445 77.4911 238.476 77.3501 238.508L76.6923 238.633L76.8187 237.944C76.8503 237.787 76.8818 237.639 76.9133 237.49L76.9135 237.489C76.945 237.34 76.9766 237.192 77.0081 237.035C79.6273 224.753 89.9833 210.653 98.9859 200.783C97.83 199.185 96.7368 197.555 95.7063 195.863ZM58.6725 172.834L58.6717 172.834C51.8938 181.701 48.2437 192.574 45.8774 203.478C54.8851 209.494 64.8026 214.475 75.6029 215.76C76.1996 214.695 76.7962 213.661 77.3928 212.627C69.0672 210.684 61.4027 206.58 54.3031 201.66L52.7081 200.532L53.0871 198.527C54.7923 189.816 57.4366 181.231 62.0518 173.742C60.9253 173.461 59.7989 173.147 58.6725 172.834ZM216.081 156.028L216.177 156.028C216.085 151.429 214.274 147.236 211.389 144.177C209.722 142.391 207.679 141.012 205.386 140.103L201.656 143.362C205.491 146.401 207.853 151.195 207.862 156.397L207.779 156.396C207.654 161.443 205.322 166.07 201.594 169.032L205.315 172.29C207.602 171.382 209.64 170.003 211.302 168.217C214.25 165.084 216.074 160.76 216.081 156.028ZM156.576 221.484C191.036 221.483 219.134 192.307 219.368 156.366L219.476 156.366C219.417 120.27 191.178 90.9104 156.522 90.91C121.866 90.9096 93.724 120.237 93.7837 156.333L93.9985 156.333C94.0799 192.304 122.095 221.484 156.576 221.484ZM97.2862 156.061L97.0815 156.061C97.1772 148.783 101.592 142.547 107.82 140.071L111.593 143.33C107.831 146.369 105.421 151.1 105.43 156.364L105.618 156.364C105.709 161.494 108.089 166.089 111.762 169.064L107.999 172.323C101.71 169.816 97.274 163.456 97.2862 156.061ZM107.869 156.03L107.694 156.03C107.788 151.435 109.985 147.373 113.29 144.834L123.979 154.108C123.979 154.238 123.971 154.359 123.963 154.476C123.956 154.586 123.948 154.692 123.948 154.798C119.671 155.068 115.908 155.385 111.733 156.03L109.874 156.03C110.175 156.082 110.474 156.133 110.771 156.183C110.417 156.241 110.06 156.301 109.7 156.364L111.902 156.364C116.066 157.009 119.82 157.326 124.086 157.596C124.086 157.702 124.093 157.808 124.101 157.917L124.101 157.918C124.108 158.035 124.117 158.156 124.117 158.285L113.455 167.56C110.078 164.959 107.862 160.761 107.869 156.03ZM126.938 156.029L126.809 156.029C126.955 139.138 140.238 125.47 156.579 125.47C172.889 125.471 186.216 139.138 186.419 156.029L186.399 156.029C186.37 173.074 173.009 186.923 156.633 186.923C140.226 186.924 126.91 173.075 126.938 156.029ZM204.34 156.185L204.307 156.191L204.409 156.209C204.255 156.243 204.101 156.267 203.943 156.293L203.943 156.293C203.81 156.315 203.673 156.337 203.53 156.365L203.272 156.365C198.649 157.107 195.035 157.187 190.716 157.281C190.498 157.286 190.278 157.291 190.056 157.295C189.799 157.301 189.539 157.307 189.277 157.313C189.261 157.47 189.253 157.634 189.245 157.798L189.245 157.799C189.237 157.963 189.228 158.128 189.213 158.285L199.874 167.559C203.386 164.864 205.491 160.634 205.498 156.028L205.566 156.027C205.458 151.553 203.366 147.463 199.932 144.835L189.242 154.109C189.258 154.266 189.266 154.43 189.275 154.595L189.275 154.596C189.283 154.76 189.291 154.924 189.307 155.08C189.798 155.092 190.278 155.102 190.75 155.113C195.08 155.207 198.703 155.286 203.338 156.028L203.463 156.028C203.549 156.046 203.633 156.061 203.715 156.074C203.769 156.083 203.822 156.092 203.875 156.101L203.875 156.101L203.876 156.101C204.034 156.126 204.187 156.151 204.34 156.185ZM205.822 187.769C205.787 189.962 205.439 192.061 204.778 194.035C207.603 190.119 210.021 185.889 211.938 181.408L204.643 180.719C205.454 182.975 205.857 185.387 205.822 187.769ZM179.995 203.436C182.217 204.501 184.595 205.002 186.975 204.971C196.056 204.877 203.427 197.2 203.568 187.706C203.572 185.231 203.106 182.756 202.107 180.437L197.255 179.967C197.348 180.75 197.378 181.502 197.377 182.286C197.299 191.247 190.368 198.454 181.788 198.548C181.036 198.548 180.285 198.485 179.565 198.391L179.995 203.436ZM180.21 206.162L180.855 213.744C185.211 211.739 189.285 209.232 192.985 206.318C191.105 206.976 189.069 207.352 186.971 207.384C184.685 207.415 182.369 207.008 180.21 206.162ZM173.849 208.888C171.995 213.086 168.765 216.502 164.816 218.476C169.577 217.786 174.181 216.533 178.536 214.747L173.849 208.888ZM157.806 191.876L157.806 191.876C157.706 196.576 157.622 200.511 156.758 205.786C155.797 200.083 155.46 195.415 155.093 189.931C155 189.931 154.914 189.924 154.828 189.916C154.742 189.908 154.655 189.9 154.561 189.9L145.557 201.149C148.055 204.689 152.059 206.977 156.6 206.977C161.14 206.976 165.151 204.689 167.662 201.148L158.694 189.9C158.554 189.9 158.413 189.908 158.272 189.916C158.131 189.923 157.99 189.931 157.849 189.931C157.833 190.594 157.819 191.238 157.806 191.869L157.806 191.872L157.806 191.876ZM172.194 206.82L169.1 202.934C166.213 206.851 161.637 209.358 156.596 209.389C151.523 209.389 146.988 206.851 144.113 202.935L141.007 206.82C143.376 213.4 149.474 218.037 156.582 218.037C163.689 218.037 169.771 213.4 172.194 206.82ZM139.375 208.888L134.669 214.747C138.987 216.533 143.588 217.787 148.377 218.476C144.435 216.471 141.216 213.087 139.375 208.888ZM132.992 206.131C130.83 206.977 128.513 207.416 126.227 207.384C124.13 207.353 122.094 206.977 120.217 206.288C123.938 209.264 128.005 211.739 132.322 213.745L132.992 206.131ZM107.441 187.739C107.414 185.357 107.825 182.976 108.643 180.689L101.346 181.378C103.249 185.89 105.653 190.151 108.464 194.037C107.81 192.063 107.469 189.932 107.441 187.739ZM115.936 182.287C115.906 181.503 115.97 180.72 116.065 179.968L111.242 180.438C110.236 182.725 109.732 185.232 109.758 187.707C109.837 197.201 117.183 204.878 126.262 204.972C128.642 205.003 131.023 204.47 133.248 203.436L133.694 198.392C132.943 198.517 132.222 198.548 131.47 198.548C122.923 198.454 116.015 191.216 115.936 182.287ZM100.38 178.934L106.024 174.046C101.988 172.103 98.7682 168.751 96.8337 164.615C97.483 169.597 98.6962 174.391 100.38 178.934ZM124.425 161.168L104.294 178.683L130.443 176.239C129.131 174.39 127.976 172.385 127.039 170.255C125.254 170.975 123.907 171.508 122.872 171.915C121.4 172.511 120.648 172.793 119.865 173.075C119.082 173.357 118.33 173.607 116.826 174.109C115.636 174.485 114.007 175.017 111.97 175.707L111.813 175.769L111.595 175.55L111.595 175.237L111.752 175.143C112.508 174.728 113.193 174.351 113.813 174.011L113.813 174.011C114.785 173.476 115.595 173.031 116.265 172.667C117.675 171.884 118.364 171.508 119.116 171.132C119.658 170.837 120.238 170.561 121.161 170.121C121.413 170.002 121.69 169.87 121.999 169.722C122.356 169.55 122.765 169.354 123.244 169.124L123.245 169.124C123.988 168.768 124.899 168.332 126.042 167.779C125.294 165.68 124.766 163.455 124.425 161.168ZM133.886 196.073L135.162 181.534C135.047 181.42 134.933 181.313 134.823 181.211L134.823 181.211C134.723 181.118 134.626 181.029 134.537 180.939C134.131 181.344 133.737 181.74 133.351 182.127L133.351 182.127C130.032 185.457 127.3 188.198 123.06 191.342C126.23 186.642 129.148 183.07 132.63 178.934C132.474 178.777 132.349 178.62 132.224 178.464L132.224 178.464L118.32 179.78C118.193 180.532 118.161 181.315 118.159 182.067C118.178 189.869 124.242 196.198 131.693 196.261C132.414 196.261 133.166 196.198 133.886 196.073ZM140.93 192.766L140.93 192.766C141.08 192.356 141.255 191.877 141.471 191.279C141.849 190.214 142.383 188.772 143.138 186.861C141.104 185.89 139.165 184.699 137.382 183.32L134.958 210.674L151.87 189.555C149.678 189.211 147.518 188.647 145.485 187.863C145.002 188.942 144.616 189.819 144.294 190.549C144.009 191.198 143.775 191.731 143.568 192.187C142.907 193.691 142.562 194.443 142.216 195.195C142.151 195.331 142.086 195.466 142.021 195.604C141.707 196.26 141.363 196.981 140.739 198.172C140.312 199.024 139.759 200.109 139.068 201.466L138.755 202.08L138.352 202.872L138.258 203.029L137.976 203.029L137.757 202.809L137.789 202.653C138.321 200.938 138.751 199.508 139.096 198.361L139.1 198.345C139.182 198.073 139.259 197.817 139.332 197.577C139.546 196.91 139.709 196.386 139.847 195.94L139.847 195.938C140.034 195.337 140.176 194.88 140.338 194.412C140.513 193.909 140.688 193.431 140.929 192.769L140.929 192.768L140.93 192.766ZM178.292 210.674L175.958 183.32C174.171 184.699 172.259 185.889 170.253 186.861C170.605 187.824 170.907 188.672 171.173 189.417L171.174 189.42C171.426 190.128 171.646 190.744 171.843 191.278C172.056 191.873 172.233 192.35 172.384 192.758C172.632 193.425 172.81 193.906 172.965 194.412C173.246 195.226 173.495 196.01 173.962 197.576C174.245 198.614 174.657 199.952 175.161 201.591C175.266 201.932 175.375 202.285 175.488 202.652L175.519 202.809L175.299 203.028L175.017 203.028L174.924 202.872C174.679 202.388 174.449 201.933 174.232 201.505L174.231 201.503C173.535 200.128 172.98 199.032 172.552 198.172L172.323 197.722L172.323 197.722L172.323 197.722C171.722 196.543 171.392 195.894 171.085 195.195C170.741 194.475 170.398 193.691 169.744 192.187C169.536 191.724 169.299 191.183 169.01 190.522C168.694 189.797 168.314 188.929 167.841 187.863C165.805 188.647 163.674 189.211 161.451 189.555L178.292 210.674ZM195.001 179.779L181.101 178.463C180.976 178.62 180.85 178.776 180.693 178.964C184.193 183.1 187.068 186.672 190.223 191.372C185.949 188.175 183.181 185.393 179.791 181.985L179.79 181.985C179.46 181.653 179.124 181.315 178.78 180.97C178.672 181.063 178.563 181.163 178.455 181.264C178.344 181.367 178.232 181.47 178.121 181.565L179.35 196.104C180.069 196.198 180.821 196.26 181.541 196.26C188.994 196.166 195.078 189.868 195.154 182.066C195.155 181.314 195.125 180.531 195.001 179.779ZM182.858 176.207L208.999 178.682L188.926 161.136C188.609 163.423 188.042 165.648 187.287 167.747C188.44 168.305 189.356 168.745 190.103 169.103L190.106 169.104L190.697 169.388C190.923 169.497 191.131 169.597 191.323 169.69C192.762 170.379 193.482 170.724 194.201 171.1C194.952 171.476 195.641 171.852 197.048 172.635C197.721 173.001 198.536 173.45 199.514 173.989L199.519 173.991L199.528 173.996C200.138 174.332 200.811 174.703 201.553 175.11L201.709 175.204L201.709 175.518L201.489 175.737L201.333 175.674C200.319 175.346 199.406 175.042 198.598 174.772L198.59 174.77L198.588 174.769C197.779 174.499 197.076 174.264 196.482 174.076L196.461 174.069L196.46 174.069C194.973 173.573 194.225 173.323 193.446 173.042C192.664 172.76 191.945 172.478 190.442 171.883C189.41 171.476 188.065 170.943 186.281 170.222C185.338 172.353 184.177 174.359 182.858 176.207ZM212.913 178.933C214.642 174.39 215.84 169.596 216.506 164.614C214.589 168.718 211.39 172.071 207.285 174.045L212.913 178.933ZM204.848 118.358C205.511 120.332 205.86 122.432 205.895 124.625C205.93 127.006 205.525 129.419 204.713 131.675L212.026 130.986C210.104 126.505 207.68 122.275 204.848 118.358ZM186.999 107.423C184.613 107.392 182.229 107.893 180.001 108.958L179.57 114.003C180.292 113.909 181.045 113.846 181.799 113.846C190.401 113.94 197.35 121.147 197.427 130.108C197.429 130.891 197.399 131.643 197.305 132.427L202.17 131.957C203.172 129.638 203.638 127.163 203.634 124.688C203.493 115.194 196.103 107.517 186.999 107.423ZM180.863 98.6495L180.217 106.232C182.382 105.386 184.704 104.979 186.995 105.01C189.099 105.042 191.14 105.418 193.024 106.076C189.315 103.162 185.231 100.655 180.863 98.6495ZM164.783 93.918C168.742 95.8921 171.98 99.3074 173.84 103.506L178.539 97.6469C174.172 95.8608 169.556 94.6075 164.783 93.918ZM156.704 106.608C157.571 111.882 157.655 115.818 157.755 120.518C157.769 121.151 157.782 121.797 157.798 122.462C157.939 122.462 158.081 122.47 158.222 122.478C158.363 122.486 158.505 122.494 158.646 122.494L167.637 111.245C165.12 107.705 161.098 105.417 156.546 105.417C151.994 105.417 147.98 107.704 145.475 111.245L154.502 122.494C154.597 122.494 154.683 122.486 154.769 122.478L154.77 122.478C154.856 122.47 154.942 122.462 155.036 122.462C155.403 116.979 155.742 112.31 156.704 106.608ZM169.078 109.459L172.18 105.574C169.751 98.9941 163.653 94.3567 156.528 94.3566C149.402 94.3566 143.288 98.9938 140.913 105.574L144.027 109.459C146.909 105.542 151.456 103.004 156.542 103.005C161.596 103.036 166.183 105.543 169.078 109.459ZM134.559 97.6463L139.277 103.506C141.123 99.3071 144.35 95.9232 148.302 93.9179C143.501 94.6072 138.888 95.8604 134.559 97.6463ZM126.096 105.01C128.387 104.978 130.71 105.417 132.878 106.263L132.206 98.649C127.877 100.654 123.8 103.129 120.07 106.106C121.952 105.417 123.992 105.041 126.096 105.01ZM108.466 131.705C107.646 129.418 107.234 127.036 107.261 124.655C107.289 122.462 107.631 120.331 108.287 118.357C105.468 122.242 103.058 126.504 101.15 131.016L108.466 131.705ZM115.907 132.426C115.812 131.674 115.747 130.891 115.777 130.107C115.857 121.177 122.782 113.939 131.352 113.846C132.106 113.846 132.828 113.877 133.581 114.002L133.134 108.958C130.903 107.924 128.516 107.391 126.131 107.422C117.027 107.516 109.663 115.193 109.584 124.687C109.557 127.162 110.063 129.668 111.072 131.956L115.907 132.426ZM105.84 138.348L100.181 133.46C98.4936 138.003 97.2773 142.797 96.6263 147.779C98.5657 143.643 101.794 140.29 105.84 138.348ZM104.106 133.71L124.288 151.226C124.63 148.938 125.159 146.714 125.909 144.615C124.763 144.062 123.849 143.625 123.104 143.269L123.1 143.267C122.621 143.039 122.213 142.843 121.857 142.672C121.547 142.524 121.268 142.392 121.016 142.272C120.091 141.833 119.509 141.557 118.966 141.262C118.212 140.886 117.521 140.51 116.108 139.726C115.437 139.363 114.626 138.919 113.654 138.386L113.648 138.383C113.027 138.042 112.341 137.666 111.582 137.251L111.425 137.157L111.425 136.844L111.644 136.624L111.801 136.687C113.843 137.376 115.476 137.909 116.67 138.285L116.67 138.285L116.67 138.285C118.178 138.787 118.931 139.037 119.717 139.319C120.502 139.601 121.256 139.883 122.732 140.478C123.769 140.886 125.12 141.419 126.91 142.139C127.848 140.009 129.006 138.003 130.322 136.155L104.106 133.71ZM135.053 130.859L133.774 116.321C133.052 116.196 132.298 116.133 131.576 116.133C124.105 116.195 118.025 122.525 118.007 130.327C118.008 131.079 118.041 131.862 118.168 132.614L132.107 133.93L132.108 133.93C132.233 133.773 132.358 133.617 132.515 133.46C129.023 129.324 126.098 125.752 122.92 121.052C127.171 124.195 129.91 126.937 133.237 130.266C133.624 130.654 134.02 131.05 134.426 131.455C134.516 131.365 134.613 131.275 134.713 131.182C134.824 131.08 134.938 130.974 135.053 130.859ZM140.836 119.628L140.836 119.627L140.836 119.626C140.593 118.964 140.418 118.485 140.243 117.982C140.08 117.514 139.938 117.057 139.751 116.457L139.751 116.456L139.75 116.455C139.611 116.009 139.448 115.484 139.233 114.817C139.159 114.572 139.081 114.311 138.997 114.033C138.651 112.887 138.22 111.456 137.687 109.741L137.655 109.584L137.874 109.365L138.157 109.365L138.251 109.522C138.501 110.012 138.737 110.473 138.958 110.907L138.969 110.928L138.97 110.93C139.663 112.286 140.217 113.37 140.644 114.222C141.27 115.413 141.615 116.133 141.929 116.79C141.995 116.928 142.06 117.062 142.125 117.198C142.472 117.95 142.818 118.702 143.48 120.206C143.688 120.663 143.923 121.196 144.209 121.844C144.531 122.574 144.918 123.451 145.402 124.53C147.441 123.747 149.606 123.183 151.804 122.838L134.848 101.72L137.279 129.073C139.066 127.695 141.01 126.504 143.049 125.533C142.293 123.622 141.757 122.18 141.378 121.115C141.161 120.517 140.986 120.037 140.836 119.628ZM175.954 129.074L178.294 101.72L161.409 122.838C163.639 123.183 165.774 123.747 167.816 124.531C168.289 123.467 168.669 122.6 168.987 121.876L168.988 121.871L168.991 121.867C169.279 121.208 169.515 120.668 169.724 120.207C170.38 118.703 170.724 117.919 171.069 117.199C171.376 116.499 171.707 115.85 172.31 114.672L172.539 114.222C172.968 113.363 173.523 112.268 174.22 110.896L174.225 110.887C174.442 110.459 174.672 110.005 174.917 109.522L175.011 109.365L175.293 109.365L175.513 109.585L175.482 109.741C175.37 110.108 175.26 110.462 175.155 110.803C174.65 112.441 174.237 113.78 173.953 114.817C173.484 116.384 173.235 117.167 172.953 117.982C172.798 118.488 172.619 118.969 172.371 119.636C172.219 120.044 172.042 120.521 171.828 121.115C171.63 121.65 171.41 122.267 171.156 122.977C170.89 123.722 170.587 124.57 170.234 125.533C172.246 126.505 174.162 127.695 175.954 129.074ZM181.11 133.931L195.046 132.615C195.171 131.863 195.201 131.079 195.199 130.327C195.123 122.526 189.023 116.228 181.551 116.133C180.83 116.133 180.076 116.196 179.355 116.29L178.122 130.829C178.234 130.924 178.345 131.027 178.457 131.13L178.457 131.13L178.457 131.13C178.566 131.231 178.674 131.331 178.783 131.424C179.128 131.079 179.465 130.741 179.796 130.409L179.796 130.409C183.196 127.001 185.97 124.219 190.255 121.021C187.092 125.721 184.21 129.293 180.701 133.429C180.858 133.617 180.984 133.774 181.11 133.93L181.11 133.931ZM209.08 133.712L182.872 136.187C184.194 138.035 185.358 140.041 186.303 142.171C188.092 141.451 189.44 140.918 190.475 140.511C191.982 139.915 192.703 139.633 193.487 139.351C194.268 139.071 195.018 138.821 196.51 138.324L196.53 138.317C197.126 138.13 197.831 137.895 198.641 137.625L198.642 137.625L198.644 137.624C199.456 137.354 200.374 137.048 201.394 136.719L201.551 136.657L201.771 136.876L201.771 137.189L201.614 137.283C200.865 137.694 200.185 138.067 199.57 138.405C198.59 138.944 197.773 139.393 197.098 139.759C195.687 140.542 194.996 140.918 194.244 141.294C193.523 141.67 192.801 142.015 191.359 142.704C191.007 142.873 190.605 143.066 190.135 143.291L190.13 143.293C189.383 143.65 188.465 144.09 187.312 144.647C188.069 146.746 188.637 148.971 188.955 151.258L209.08 133.712ZM216.606 147.78C215.939 142.798 214.737 138.004 213.003 133.461L207.361 138.349C211.477 140.323 214.684 143.676 216.606 147.78Z" fill="#442F2C"/>
                </g>
                </g>
                </svg>

              
              <input id="skio-selling-plan-group-${index}-${
                    this.key
                  }" class="skio-group-input" name="skio-group-${this.key}"
                type="radio" value="${group.id}" skio-selling-plan-group="${
                    group.id
                  }" ?checked=${
                    this.selectedSellingPlanGroup == group ? true : false
                  } >
              <label class="skio-group-label" for="skio-selling-plan-group-${index}-${
                    this.key
                  }">
                <div class="skio-group-topline">
                  <div class="skio-radio__container">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"></circle>
                      <circle class="skio-radio" cx="12" cy="12" r="7" fill="currentColor"></circle>
                    </svg>
                  </div>
                  <div class="skio-group-title">
                    Subscribe + 
                    ${
                      this.discount(group.selected_selling_plan).percent !==
                      "0%"
                        ? html`
                      <span style=${
                    this.selectedSellingPlanGroup == group ? `background:${widgetColor}` : ''
                  }  class="skio-save"> Save <span skio-discount>${
                        this.discountFormat == "percent"
                          ? this.discount(group.selected_selling_plan).percent
                          : this.discount(group.selected_selling_plan).amount
                      }</span></span>
                    `
                        : html``
                    }


              ${servingsNumber?html`<div class="skio-group-sub-title">
                    <span class="skio-group-sub-title-compare">${ this.moneyFormatter.format((this.selectedVariant.price /servingsNumber/ 100)) }</span>${ this.moneyFormatter.format((this.price(group.selected_selling_plan, false)/servingsNumber/ 100)) } per stick
                      </div>`:html``}
               
                    
                  </div>
                  <div class="skio-price">
                  
                      ${this.discount(group.selected_selling_plan).percent !==
                        "0%"?html`<span skio-compare-price>${ this.moneyFormatter.format(this.selectedVariant.price / 100) }</span>
                      `
                      : html``
                      }
                    <span skio-subscription-price>${this.price(
                      group.selected_selling_plan
                    )}</span>
                    
                  </div>
                </div>
                <div class="skio-group-content">


                 
           <ul>
                <li>
                Delivery every
                 <div skio-selling-plans="${group.id}" class="dropdown-inner ${
                    group.selling_plans.length == 1 ? "skio-frequency--one" : ""
                  }">
                     <div data-dropdown class="styledSelect" @click=${(e) =>
                       this.selectSellingPlan(
                         e.target,
                         group
                       )}>${group.selected_selling_plan.name.toLowerCase().replace('every', '')}</div>
                     <ul data-values class="options hide">
                        ${
                          group
                            ? group.selling_plans.map(
                                (selling_plan) =>

                                  html`
                                    <li data-selected=${group.selected_selling_plan.id === selling_plan.id} @click=${(e) =>
                                      this.selectSellingPlan(
                                        e.target,
                                        group
                                      )} data-value="${selling_plan.id}"> ${
                                              group.name == "Subscription"
                                                ? `${selling_plan.name.toLowerCase().replace('every', '')}`
                                                : `${selling_plan.name}`
                                            }</li>
                                  `
                              )
                            : ""
                        }
                     </ul>
                </div>
          </li>
                 ${widgetText && widgetText.length > 0?html`
                   ${widgetText.map((text)=>{
                     return html`<li>${text}</li>`
                   })}
                  `:html``}
                  </ul>
               
                  
                </div>
              </label>
            </div>
          `
              )
            : ""
        }
      </fieldset>`;
  }

  updated = (changed) => {
    if (changed.has("product") && this.product) {
      //update key
      this.key = this.key ? this.key : this.product.id;

      //update skioSellingPlanGroups
      this.skioSellingPlanGroups = this.product.selling_plan_groups.filter(
        (selling_plan_group) => selling_plan_group.app_id === "SKIO"
      );

      this.skioSellingPlanGroups.forEach((group) => {
        group.selling_plans.sort(function (a, b) {
          if (
            parseInt(a.name.replace(/\D/g, "")) <
            parseInt(b.name.replace(/\D/g, ""))
          )
            return -1;
          if (
            parseInt(a.name.replace(/\D/g, "")) >
            parseInt(b.name.replace(/\D/g, ""))
          )
            return 1;
          if (
            parseInt(a.name.replace(/\D/g, "")) ==
            parseInt(b.name.replace(/\D/g, ""))
          )
            return 0;
        });
      });
    }

    if (changed.has("selectedVariant") && this.selectedVariant) {
      //update availableSellingPlanGroups based on skioSellingPlanGroups and selectedVariant.id
      this.availableSellingPlanGroups = this.skioSellingPlanGroups.filter(
        (selling_plan_group) =>
          selling_plan_group.selling_plans.some((selling_plan) =>
            this.selectedVariant.selling_plan_allocations.some(
              (selling_plan_allocation) =>
                selling_plan_allocation.selling_plan_id === selling_plan.id
            )
          )
      );

      //update selectedSellingPlan value
      if (this.availableSellingPlanGroups?.length > 0) {
        //update each group with a default selected_selling_plan
        this.availableSellingPlanGroups.forEach((group) => {
          if (this.defaultFrequency) {
            let selling_plan = group.selling_plans.find((x) =>
              x.name.toLowerCase().includes(this.defaultFrequency.toLowerCase())
            );
            if (selling_plan) group.selected_selling_plan = selling_plan;
            else group.selected_selling_plan = group.selling_plans[0];
          } else {
            group.selected_selling_plan = group.selling_plans[0];
          }
        });

        const _startSub = this.getAttribute('data-start-subscription');
        if (
          (_startSub === 'true' || (_startSub === null && this.startSubscription == true)) ||
          this.product.requires_selling_plan == true ||
          this.purchaseOption == "subscription"
        ) {
          //find a matching selling plan, or choose first available

          if (
            this.selectedSellingPlan == null ||
            this.selectedSellingPlan == undefined
          ) {
            // Prefer 30-day plan, otherwise fall back to first available
            let preferred30Group = null;
            let preferred30Plan = null;
            for (let g of this.availableSellingPlanGroups) {
              let p = g.selling_plans.find((x) => x.name.toLowerCase().includes("30"));
              if (p) { preferred30Group = g; preferred30Plan = p; break; }
            }
            this.selectedSellingPlanGroup = preferred30Group || this.availableSellingPlanGroups[0];
            this.selectedSellingPlan = preferred30Plan || this.availableSellingPlanGroups[0].selling_plans[0];
            // Also update group.selected_selling_plan so the dropdown displays correctly
            this.selectedSellingPlanGroup.selected_selling_plan = this.selectedSellingPlan;
          } else {
            let sellingPlanName = this.selectedSellingPlan.name;

            let sellingPlanGroup = this.availableSellingPlanGroups.find((x) =>
              x.selling_plans.find((y) => y.name == sellingPlanName)
            );
            let sellingPlan = sellingPlanGroup.selling_plans.find(
              (y) => y.name == sellingPlanName
            );
            if (sellingPlanName == sellingPlan.name) {
              this.selectedSellingPlanGroup = sellingPlanGroup;
              this.selectedSellingPlan = sellingPlan;
            } else {
              this.selectedSellingPlanGroup = this.availableSellingPlanGroups[0];
              this.selectedSellingPlan =
                this.availableSellingPlanGroups[0].selling_plans[0];
            }
          }
        } else {
          this.selectedSellingPlan, (this.selectedSellingPlanGroup = null);
        }
      }

      //update the form that was passed, if any
      this.updateForm();
    }

    if (changed.has("selectedSellingPlan")) {
      //update price of price elements if applicable
      document
        .querySelectorAll(`[skio-price][skio-key="${this.key}"]`)
        .forEach((el) => {
          el.innerHTML = this.price(this.selectedSellingPlan);
        });

      //update display of external content elements
      document
        .querySelectorAll(`[skio-onetime-content][skio-key="${this.key}"]`)
        .forEach((el) => {
          this.selectedSellingPlan !== null
            ? (el.style.display = "none")
            : el.style.removeProperty("display");
        });

      document
        .querySelectorAll(`[skio-subscription-content][skio-key="${this.key}"]`)
        .forEach((el) => {
          this.selectedSellingPlan == null
            ? (el.style.display = "none")
            : el.style.removeProperty("display");
        });

      //dispatch CustomEvent to tell that this specific plan picker was updated, and pass the selectedSellingPlan
      const event = new CustomEvent(`skio::update-selling-plan`, {
        bubbles: true,
        composed: true,
        detail: {
          sellingPlan: this.selectedSellingPlan,
          key: this.key,
        },
      });

      this.dispatchEvent(event);

      //update the form that was passed, if any
      this.updateForm();
      this.updateExternalPrice();

      //update external selling_plan input value
      let sellingPlanInput = document.querySelector(
        'input[name="selling_plan"]'
      );
      this.selectedSellingPlan != null
        ? (sellingPlanInput.value = this.selectedSellingPlan.id)
        : (sellingPlanInput.value = "");
    }

    if (changed.has("formId")) {
      //update the form that was passed, if any
      this.updateForm();
    }
    let customDiscount = this.getAttribute('data-custom-discount');
    var customOneTimePrice = this.selectedVariant.price;
    let discountAmount = this.customDiscountAmount(customOneTimePrice, customDiscount);
    let finalPrice = customOneTimePrice - discountAmount;
    if(customDiscount != '' && window.customDiscountEnabled && this.selectedSellingPlanGroup == null){
      const comparePrice = this.selectedVariant.compare_at_price || customOneTimePrice;
      document.querySelectorAll('[add-to-cart-price]').forEach((el) => {
        let priceHtml = `<span>${this.moneyFormatter.format(finalPrice / 100)}</span>`;
        if(comparePrice > finalPrice){
          priceHtml += ` <span><s class="price-item price-item--regular">${this.moneyFormatter.format(comparePrice / 100)}</s></span>`;
        }
        el.innerHTML = priceHtml;
      });
    } else if(this.selectedSellingPlanGroup != null && this.selectedSellingPlan != null){
      const subsPrice = this.price(this.selectedSellingPlan, false);
      const comparePrice = this.selectedVariant.compare_at_price || customOneTimePrice;
      document.querySelectorAll('[add-to-cart-price]').forEach((el) => {
        let priceHtml = `<span>${this.moneyFormatter.format(subsPrice / 100)}</span>`;
        if(comparePrice > subsPrice){
          priceHtml += ` <span><s class="price-item price-item--regular">${this.moneyFormatter.format(comparePrice / 100)}</s></span>`;
        }
        el.innerHTML = priceHtml;
      });
    }

  };

  log = (...args) => {
    args.unshift("%c[skio]", "color: #8770f2;");
    console.log.apply(console, args);
  };

  error = (...args) => {
    args.unshift("%c [skio]", "color: #ff0000");
    console.error.apply(console, args);
  };

  updateExternalPrice() {
  
    document.querySelectorAll(this.externalPriceSelector).forEach((el) => {
      el.innerHTML = this.price(this.selectedSellingPlan);
    });
    document
      .querySelectorAll(this.externalPriceSelectorWithCurrency)
      .forEach((el) => {
        el.innerHTML = this.price(this.selectedSellingPlan);
      });
  }

  // Update selected selling plan group; called on click of skio-group-container element
  selectSellingPlanGroup(group) {
  
    this.selectedSellingPlanGroup = group;
    this.selectedSellingPlan = group?.selected_selling_plan;
    if (group) this.purchaseOption = "subscription";
    else this.purchaseOption = "onetime";

    //update the form that was passed, if any
    this.updateForm();


  }

  // Update selected selling plan; called on change of skio-frequency select element
  selectSellingPlan(element, group) {
    
    if (element.hasAttribute("data-dropdown")) {
      element.classList.toggle("active");
      element.nextElementSibling.classList.toggle("hide");
      return false;
    } else {
      element.parentElement.classList.toggle("hide");
      element.parentElement.previousElementSibling.classList.toggle("active");
    }

    // if(document.querySelector('[data-dropdown]') != null) {
    //  document.querySelector('[data-values]').classList.toggle('hide-dropdown');
    //  document.querySelector('[data-dropdown]').classList.remove('active');
    // }

    let selling_plan = group.selling_plans.find(
      (x) => x.id == element.getAttribute("data-value")
    );

    if (selling_plan) {
      group.selected_selling_plan = selling_plan;
      this.selectedSellingPlanGroup = group;
      this.selectedSellingPlan = selling_plan;
      this.requestUpdate();
    } else
      this.log(
        "Error: couldn't find selling plan with id " +
          element.value +
          " for variant " +
          this.selectedVariant.id +
          " from product " +
          this.product.id +
          " : " +
          this.product.handle
      );
  }

  // Formats integer value into money value
  money(price) {
    return this.moneyFormatter.format(price / 100.0);
  }

  customDiscountAmount(price, discountPercentage) {
    const discount = Number(discountPercentage);
    if (!Number.isFinite(discount)) return 0;

    return Math.floor((price * discount) / 100);
  }

  // Calculates discount based on selling_plan.price_adjustments, returns { percent, amount } of selling plan discount
  discount(selling_plan) {
    if (!selling_plan) return { percent: "0%", amount: 0 };

    const price_adjustment = selling_plan.price_adjustments[0];
    const discount = { percent: "0%", amount: 0 };
    const price = this.selectedVariant.price;

    switch (price_adjustment.value_type) {
      case "percentage":
        discount.percent = `${price_adjustment.value}%`;
        discount.amount = Math.round((price * price_adjustment.value) / 100.0);
        break;
      case "fixed_amount":
        discount.percent = `${Math.round(
          ((price_adjustment.value * 1.0) / price) * 100.0
        )}%`;
        discount.amount = price_adjustment.value;
        break;
      case "price":
        discount.percent = `${Math.round(
          (((price - price_adjustment.value) * 1.0) / price) * 100.0
        )}%`;
        discount.amount = price - price_adjustment.value;
        break;
    }

    return discount;
  }

  // Calculates the variant's price for the given selling plan, returns a formatted money value (if desired)
  price(selling_plan, formatted = true) {
    return formatted
      ? this.money(
          this.selectedVariant.price - this.discount(selling_plan).amount
        )
      : this.selectedVariant.price - this.discount(selling_plan).amount;
  }

  // If a formId was passed, appends the necessary <input> elements to the form
  updateForm() {
    if (this.formId) {
      let form = document.querySelector(`#${this.formId}`);

      if (form) {
        let selling_plan_input = form.querySelector('[name="selling_plan"]');
        if (selling_plan_input) {
          selling_plan_input.value =
            this.selectedSellingPlan?.id !== undefined
              ? this.selectedSellingPlan?.id
              : null;
          selling_plan_input.disabled =
            this.selectedSellingPlan?.id !== undefined ? false : true;
        } else {
          selling_plan_input = document.createElement("input");
          selling_plan_input.type = "hidden";
          selling_plan_input.name = "selling_plan";
          selling_plan_input.value =
            this.selectedSellingPlan?.id !== undefined
              ? this.selectedSellingPlan?.id
              : null;
          selling_plan_input.disabled =
            this.selectedSellingPlan?.id !== undefined ? false : true;
          form.append(selling_plan_input);
        }

        let discount_input = form.querySelector(
          '[name="properties[Discount]"]'
        );
        if (discount_input) {
          discount_input.value =
            this.selectedSellingPlan?.id !== undefined
              ? this.discount(this.selectedSellingPlan).percent
              : null;
          discount_input.disabled =
            this.selectedSellingPlan?.id !== undefined ? false : true;
        } else {
          discount_input = document.createElement("input");
          discount_input.type = "hidden";
          discount_input.name = "properties[Discount]";
          discount_input.value =
            this.selectedSellingPlan?.id !== undefined
              ? this.discount(this.selectedSellingPlan).percent
              : null;
          discount_input.disabled =
            this.selectedSellingPlan?.id !== undefined ? false : true;
          form.append(discount_input);
        }
      } else {
        console.log(
          `Skio error: form ID is ${this.formId}, but no form with that ID was found.`
        );
      }
    }
  }

  addVariantClickEventListeners() {
    let variantInputs = document.querySelectorAll(this.variantInputSelector);
    let skio = this;
    for (let el of variantInputs) {
      el.addEventListener("click", function (e) {
        // may need to replace with ID / e.target depending on client setup
        // may need to use different attribute depending on ^^
        let variantTitle = e.currentTarget.value;
        skio.selectedVariant = skio.product.variants.find(
          (variant) => variant.title == variantTitle
        );
      });
    }
  }

  // Optional functions keep if necessary

  /**
   *
   *
   */

  // Runs a fetch request to add the selectedVariant to the cart with the passed quantity and selectedSellingPlan
  addToCart(quantity) {
    const items = [
      {
        id: this.selectedVariant.id,
        quantity: quantity,
        ...(this.selectedSellingPlan && {
          selling_plan: this.selectedSellingPlan?.id,
        }),
      },
    ];

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items }),
    })
      .then((response) => response.json())
      .then((response) => {
        this.log("SKIO added item to cart: ", response);
        //dispatch CustomEvent to tell document that an item was added to cart
        const event = new CustomEvent(`skio::added-to-cart`, {
          bubbles: true,
          composed: true,
          detail: {
            response,
            key: this.key,
          },
        });

        this.dispatchEvent(event);
      })
      .catch((error) => {
        this.error(`SKIO ${this.key} error adding item to cart: `, error);
      });
  }

  fetchProduct = (handle) => {
    return fetch(`/products/${handle}.js`)
      .then((response) => response.json())
      .then((product) => {
        this.product = product;
        this.selectedVariant = product.variants[0];

        return product;
      });
  };
}

customElements.define("skio-plan-picker", SkioPlanPickerComponent);
